"use strict";

class SalesApplicationSummaryController {

    constructor($scope,
                $window,
                $timeout,
                Fullscreen,
                SSAppService,
                SSHttpService,
                SSUtilService,
                SSDateService,
                SSAlertService,
                SSConfirmationService,
                SSConfigService,
                SSUserService,
                SSEoiService,
                OTPService,
                SettingsService,
                SSLockService
    ) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;

        self.$scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
            self.initSelectizejsClass();
            // self.checkIfRequired();
        });

        self.Fullscreen = Fullscreen;

        self.SSAppService = SSAppService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.SSEoiService = SSEoiService;
        self.OTPService = OTPService;
        self.SettingsService = SettingsService;
        self.SSLockService = SSLockService;

        self.data = SHOWSUITE.data;
        self.parameters = self.data.url_param;

        //Commissions & Incentives
        self.propertyCommissions = null;
        self.saleCommissions = null;
        self.current_sale_commission_params = {};

        self.data = SHOWSUITE.data;
        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;
        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SPA_LETTER;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2;

        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;
        self.ASSET_MODEL_EOI_INSTRUMENT = SHOWSUITE.ASSET_MODEL_EOI_INSTRUMENT;
        self.ASSET_MODEL_PAYMENT_INSTRUMENT = SHOWSUITE.ASSET_MODEL_PAYMENT_INSTRUMENT;

        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;
        self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
        self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_EXERCISED = SHOWSUITE.SALE_STATUS_EXERCISED;
        self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
        self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;

        self.LOCK_TYPE_SALE_APPLICATION_REVIEW = SHOWSUITE.LOCK_TYPE_SALE_APPLICATION_REVIEW;
        self.LOCK_TYPE_SALE_GENERATE_OTP = SHOWSUITE.LOCK_TYPE_SALE_GENERATE_OTP;

        self.TYPE_BUYER_VIEW = 'buyer_view';
        self.TYPE_DOCUMENT_VIEW = 'document_view';

        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;

        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;

        self.PAYMENT_TYPE_01_BOOKING_FEE = SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE;

        self.PROPERTY_TYPE_EXECUTIVE_CONDO = SHOWSUITE.PROPERTY_TYPE_EXECUTIVE_CONDO;

        self.QUESTION_ENTITY_TYPE_BUYER = SHOWSUITE.QUESTION_ENTITY_TYPE_BUYER;
        self.QUESTION_ENTITY_TYPE_DEVELOPER = SHOWSUITE.QUESTION_ENTITY_TYPE_DEVELOPER;

        self.QUESTION_MARKER_SPECIAL_CONDITIONS = SHOWSUITE.QUESTION_MARKER_SPECIAL_CONDITIONS;

        self.QUESTION_PHASE_EOI = SHOWSUITE.QUESTION_PHASE_EOI;
        self.QUESTION_PHASE_BOOKING = SHOWSUITE.QUESTION_PHASE_BOOKING;

        self.QUESTION_TYPE_YES_NO = SHOWSUITE.QUESTION_TYPE_YES_NO;
        self.QUESTION_TYPE_YES_NO_NA = SHOWSUITE.QUESTION_TYPE_YES_NO_NA;
        self.QUESTION_TYPE_TEXT = SHOWSUITE.QUESTION_TYPE_TEXT;
        self.QUESTION_TYPE_NUMBER = SHOWSUITE.QUESTION_TYPE_NUMBER;
        self.QUESTION_TYPE_SELECT = SHOWSUITE.QUESTION_TYPE_SELECT;
        self.QUESTION_TYPE_CHECKBOX = SHOWSUITE.QUESTION_TYPE_CHECKBOX;
        self.QUESTION_TYPE_RADIO = SHOWSUITE.QUESTION_TYPE_RADIO;
        self.QUESTION_TYPE_DATE = SHOWSUITE.QUESTION_TYPE_DATE;

        self.ROUNDING_METHOD_STANDARD = SHOWSUITE.ROUNDING_METHOD_STANDARD;
        self.ROUNDING_METHOD_FLOOR = SHOWSUITE.ROUNDING_METHOD_FLOOR;
        self.ROUNDING_METHOD_CEIL = SHOWSUITE.ROUNDING_METHOD_CEIL;

        self.ROUND_TO_ONE = SHOWSUITE.ROUND_TO_ONE;
        self.ROUND_TO_TEN = SHOWSUITE.ROUND_TO_TEN;
        self.ROUND_TO_HUNDRED = SHOWSUITE.ROUND_TO_HUNDRED;
        self.ROUND_TO_THOUSAND = SHOWSUITE.ROUND_TO_THOUSAND;

        self.sale_statuses = [
            {
                id: self.SALE_STATUS_DRAFT,
                name: "Draft"
            },
            {
                id: self.SALE_STATUS_PENDING,
                name: "Pending"
            },
            {
                id: self.SALE_STATUS_SUBMITTED,
                name: "Submitted"
            },
            {
                id: self.SALE_STATUS_VERIFIED,
                name: "Verified"
            },
            {
                id: self.SALE_STATUS_APPROVED,
                name: "Approved"
            },
            {
                id: self.SALE_STATUS_REJECTED,
                name: "Rejected"
            },
            {
                id: self.SALE_STATUS_OTP,
                name: "OTP Generated"
            },
            {
                id: self.SALE_STATUS_CHEQUE_ENTERED,
                name: "Cheque Entered"
            },
            {
                id: self.SALE_STATUS_SPA_ENTERED,
                name: "SPA Entered"
            },
            {
                id: self.SALE_STATUS_EXTENDED,
                name: "Sale Extended"
            },
            {
                id: self.SALE_STATUS_EXERCISED,
                name: "Sale Exercised"
            },
            {
                id: self.SALE_STATUS_EXPIRED,
                name: "Sale Expired"
            },
            {
                id: self.SALE_STATUS_ABORTED,
                name: "Sale Aborted"
            },
            {
                id: self.SALE_STATUS_INVALID,
                name: "Sale Invalid"
            },
            {
                id: self.SALE_STATUS_DONE,
                name: "Sale Completed"
            },
            {
                id: self.SALE_STATUS_DELETED,
                name: "Sale Deleted"
            }
        ];

        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_DEBIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD; 
        self.DISCOUNT_TYPE_STAFF = SHOWSUITE.DISCOUNT_TYPE_STAFF;
        self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_OTHER = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_OTHER
        self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;

        self.BENEFICIARY_IDENTITY_NRIC = SHOWSUITE.BENEFICIARY_IDENTITY_NRIC;
        self.BENEFICIARY_IDENTITY_PASSPORT = SHOWSUITE.BENEFICIARY_IDENTITY_PASSPORT;
        self.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE = SHOWSUITE.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE;

        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE;

        self.unable_action = true;
        self.buyer_document_missing = false;
        self.payment_missing_document = false;

        self.fatf_blacklist_countries = [];
        self.cbi_rbi_countries = [];
        self.occupations_blacklist = {};

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }

        self.$timeout(function () {
            $(document).ready(function () {
                $('.zoom').magnify();
            });
        }, 6000);

        self.saleAgencyEditMode = false;
        self.commissionEditMode = false;

        self.updateSaleParams = {};
        self.updateSaleEditMode = false;

        self.addBrokerParams = [];

        self.developer_users = [];
        self.developerUser = null;

        self.pageSize = 8; // Number of documents per page
        self.currentPage = 1; // Start with the first page

        self.selected_property_id = null; // Init property id

        // WEB-4375: `lock_name` of the sale review lock held by this page, as
        // returned by the unified acquire, plus the $timeout promise of the
        // heartbeat that keeps it alive. Both are null when no lock is held.
        self.sale_lock_name = null;
        self.lock_ping_promise = null;
    }

    init() {
        const self = this;

        self.sale = {};
        self.buyer_types = {};
        self.buyer_types[self.BUYER_TYPE_INDIVIDUAL] = 'Individual';
        self.buyer_types[self.BUYER_TYPE_COMPANY] = 'Company';

        self.eoiNonBuyerPayees = {};
        self.booking_fee_percentage = 5;

        self.nationalities = self.SSConfigService.getNationalities();
        self.genders = self.SSConfigService.getGenders();
        self.maritalStatuses = self.SSConfigService.getMaritalStatuses();
        self.countries = self.SSConfigService.getCountries();
        self.SALE_TYPES = self.SSConfigService.getSaleTypes();

        $('#otpDatepickerThree').datepicker({dateFormat: 'dd/mm/yy'});
        self.otp_date = moment().format('DD/MM/YYYY');
        self.editBankinDate = false;

        /** WEB-2811 AMS/DMS : AUS country support **/
        self.is_payment_section_disabled = false;
        self.is_upload_doc_section_disabled = false;
        self.is_otp_spa_doc_type_none = false;

        self.getDeveloperSettings();

        self.getSaleOtpRepresentative();

        self.initPurchaseMode();
        self.initLockSale();
        self.initLockTeardown();

        document.addEventListener('fullscreenchange', self.exitHandler);
        document.addEventListener('webkitfullscreenchange', self.exitHandler);
        document.addEventListener('mozfullscreenchange', self.exitHandler);
        document.addEventListener('MSFullscreenChange', self.exitHandler);

        $('#sale_remarks').on('input propertychange', function() {
            var len = this.value.length;
            $('#remainingC').text(500 - len + ' characters remaining');
            
            if (len > 500) {
                this.value = this.value.substring(0, 500);
                $('#remainingC').text(0 + ' characters remaining');
            }
        });
    }

    getPropertyQuestions(property_id) {
        const self = this;

        self.buyerQuestions = [];
        self.questions = [];

        //Get property questions
        let url = 'sec/developer/properties/' + property_id + '/questions';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let property_questions = response.data.property_questions.filter(item => item.is_active === 1);

            property_questions = _.sortBy(property_questions, "order");

            // Filter questions for 'BUYERS'
            self.buyerQuestions = self.SSEoiService.getQuestions(
                self.QUESTION_ENTITY_TYPE_BUYER,
                self.QUESTION_PHASE_BOOKING,
                null,
                property_questions,
                true
            );

            // Filter questions for 'DEVELOPER'
            self.questions = self.SSEoiService.getQuestions(
                self.QUESTION_ENTITY_TYPE_DEVELOPER,
                self.QUESTION_PHASE_BOOKING,
                null,
                property_questions
            );

            self.bindQuestionAnswers();
        });
    }

    bindQuestionAnswers() {
        const self = this;

        $.each(self.buyerQuestions, function (index, question) {

            if (self.sale.question_answers) {
                $.each(self.sale.question_answers, function (i, answer) {
                    if (answer.code === question.code) {
                        question.answer_text = answer.answer_text;
                        return false;
                    }
                });
            }

            if (question.type === SHOWSUITE.QUESTION_TYPE_CHECKBOX
                || question.type === SHOWSUITE.QUESTION_TYPE_SELECT
                || question.type === SHOWSUITE.QUESTION_TYPE_RADIO
            ) {
                // Process answer
                let answer_array = [];
                if (question.answer_text) {
                    try {
                        answer_array = JSON.parse(question.answer_text);
                        if(typeof answer_array === 'number'){ // JSON string parses number in string to number causing error
                            answer_array = [question.answer_text];
                        }
                    } catch (e) { // Means is just a plain text
                        answer_array = [question.answer_text];
                    }
                }

                question.formatted_choices = [];
                $.each(JSON.parse(question.choices), function (j, choice) {
                    question.formatted_choices.push({
                        label: choice,
                        answer: answer_array.indexOf(choice) > -1
                    });
                });
            }

            self.SSEoiService.findParentQuestion(self.buyerQuestions, question); // Set parent question object

            // Filter Marker Questions
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_SPECIAL_CONDITIONS)) {
                self.saleQuestionSpecialConditions = question;
            }
        });

        $.each(self.questions, function (index, question) {

            if (self.sale.question_answers) {
                $.each(self.sale.question_answers, function (i, answer) {
                    if (answer.code == question.code) {
                        question.answer_text = answer.answer_text;
                        return false;
                    }
                });
            }

            if (question.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX
                || question.type == SHOWSUITE.QUESTION_TYPE_SELECT
                || question.type == SHOWSUITE.QUESTION_TYPE_RADIO
            ) {
                // Process answer
                let answer_array = [];
                if (question.answer_text) {
                    try {
                        answer_array = JSON.parse(question.answer_text);
                        if(typeof answer_array === 'number'){ // JSON string parses number in string to number causing error
                            answer_array = [question.answer_text];
                        }
                    } catch (e) { // Means is just a plain text
                        answer_array = [question.answer_text];
                    }
                }

                question.formatted_choices = [];
                $.each(JSON.parse(question.choices), function (j, choice) {
                    question.formatted_choices.push({
                        label: choice,
                        answer: answer_array.indexOf(choice) > -1
                    });
                });
            }

            self.SSEoiService.findParentQuestion(self.questions, question); // Set parent question object

            // Filter Marker Questions
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_SPECIAL_CONDITIONS)) {
                self.saleQuestionSpecialConditions = question;
            }
        });

        self.$timeout(function () {
            $('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+20",
                dateFormat: "dd/mm/yy"
            });
        });

        self.$timeout(function () {
            $("select.eoi-select.questionaire_select").niceSelect('update');
        });
    }

    initPurchaseMode() {
        const self = this;

        if (!!SHOWSUITE.data.config) {
            self.purchase_modes = SHOWSUITE.data.config.purchase_modes;
        } else {
            self.purchase_modes = null;
        }
    }

    exitHandler() {
        if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
            $('img').css({"width": "100%", "height": ""});
        }
    }

    printSummary() {
        const self = this;

        var divToPrint = document.getElementById('summary');

        let review_label = $('p.review');
        let img_preview = $('img.preview');
        review_label.hide();

        $('.card-header').css({
            "border-top": "1px solid #e5e5e5",
            "border-left": "1px solid #e5e5e5",
            "border-right": "1px solid #e5e5e5"
        });
        $('.mt-4').css({"margin-top": "1rem !important"});

        $('.col-md-1').css({"width": "12.3333333333%", "display": "inline-block"});
        $('.col-md-2').css({"width": "16.6666666667%", "display": "inline-block"});
        $('.col-md-3').css({"width": "25%", "display": "inline-block"});
        $('.col-md-4').css({"width": "33.3333333333%", "display": "inline-block"});
        $('.col-md-6').css({"width": "47.3333333333%", "display": "inline-block"});
        $('.col-md-7').css({"width": "49.3333333333%", "display": "inline-block"});

        $(".document-container").css({"width": "45%", "display": "inline-block"});

        img_preview.css({"width": "260px", "height": "160px"});

        let divName = "summary";
        var newWin = window.open('', 'Print-Window', 'width=1050,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
        var str = "<html";
        str = str + "<body>";
        str = str + document.getElementById(divName).innerHTML;
        str = str + "</body>";
        str = str + "</html>";

        newWin.document.open();
        newWin.document.write(str);

        // Wait for 100 ms (100 m.sec) to load the data
        self.$timeout(function () {

            try {

                newWin.document.close();
                newWin.focus();

                try {
                    if (self.SSUtilService.getBrowserName() == 'firefox') {
                        newWin.print();
                    } else {
                        newWin.document.execCommand('print', false, null);
                    }
                } catch (e) {
                    console.log(e);
                    newWin.print();
                }

                newWin.close();
            } catch (ex) {
                console.log(ex);
            }

        }, 100);

        review_label.show();
        img_preview.removeAttr("style");
        $(".document-container").removeAttr("style");
    }

    getOtpDocs() {
        const self = this;
        self.otp_documents = [];
        self.spa_documents = [];

        if (!self.sale['property'].property_documents) {
            self.otp_documents = [{
                id: null,
                name: 'Default'
            }];
            self.spa_documents = [{
                id: null,
                name: 'Default'
            }];
            return;
        }

        $.each(self.sale['property'].property_documents, function (i, e) {
            if (e.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP) {
                self.otp_documents.push(e);
            }
            if (e.document_kind == self.PROPERTY_DOCUMENT_KIND_SPA_LETTER) {
                self.spa_documents.push(e);
            }
        });

        if (self.otp_documents.length == 0) {
            self.otp_documents = [{
                id: null,
                name: 'Default'
            }];
        }
        if (self.spa_documents.length == 0) {
            self.spa_documents = [{
                id: null,
                name: 'Default'
            }];
        }
    }

    checkPermission(permission){
        const self = this;

        if(!(permission && self.sale.property)){
            return false;
        }

        return self.SSUserService.hasPermissionForProperty(permission, self.sale.property.id);
    }

    prepareSaleObject() {
        const self = this;

        let url = 'sec/developer/sales/' + self.data.sale_id;

        let params = {
            'include': 'eois, properties, units, brokers, agencies, sale_buyers, non_buyer_payees, question_answers, documents, payments, history, sale_discounts, unit_price_schedule, beneficiaries, payment_plans, sale_selections,property_settings, witnesses'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale = response.data.sales[0];
            
            let paymentPlans = response.data.payment_plans;

            self.sale.payment_plan_name = '--';
            if(paymentPlans && paymentPlans.length){
              let selectedPaymentPlan = paymentPlans.find(x => x.id == self.sale.payment_plan_id);
              if(selectedPaymentPlan){
                self.sale.payment_plan_name = selectedPaymentPlan.name;
              }
            }

            if (self.sale.status == self.SALE_STATUS_APPROVED || self.sale.status == self.SALE_STATUS_REJECTED || self.sale.status == self.SALE_STATUS_OTP) {
                self.unable_action = true;
            } else {
                self.unable_action = false;
            }
            self.priceCopy = angular.copy(self.sale.price);
            // self.unitsCommissionIncentives = response.data.unitsCommissionIncentives;
            self.agencies = response.data.agencies;

            self.sale.commission_gst_inclusive = self.sale.commission_gst_inclusive ? self.sale.commission_gst_inclusive : 0;
            self.sale.gst_inclusive = self.sale.gst_inclusive ? self.sale.gst_inclusive : 0;

            let identity_types = self.SSConfigService.getIdentityTypes(response.data.properties[0].country);

            self.sale['buyers'] = [];

            $.each(self.sale.sale_buyers, function (index, buyer) {
                let processed_buyer = JSON.parse(buyer.data);
                processed_buyer['documents'] = [];
                processed_buyer['sale_buyer_id'] = buyer.id;
                let temp_buyer = self.SSEoiService.types.find(x => x.id == processed_buyer.type);
                if (temp_buyer) {
                    processed_buyer["type_name"] = temp_buyer.name;
                }
                if (processed_buyer.type == self.BUYER_TYPE_INDIVIDUAL) {
                    let identity_type_obj = identity_types.find(x => x.id == processed_buyer.individual.identity_type);
                    if (identity_type_obj) {
                        processed_buyer["identity_type_name"] = identity_type_obj.name;
                    }

                    let nationality_obj = self.nationalities.find(x => x.id == processed_buyer.individual.nationality);
                    if (nationality_obj) {
                        processed_buyer["nationality_name"] = nationality_obj.name;
                    }
                }

                self.sale['buyers'].push(processed_buyer);
            });

            /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
            self.SSEoiService.buyers = self.sale.buyers || null;

            /** WEB-2901 FATF Black List - Indications **/
            self.checkBuyersAgainstFatfList("BUYER");
            self.checkBuyersAgainstFatfList("BENEFICIARY");

            // if (self.sale.buyers.length > 0) {
            //   self.changeDisplayDoc(self.sale.buyers[0], self.TYPE_BUYER_VIEW);
            // }

            self.getSalesNonBuyerPayees();
            self.getSalesWitnesses();

            let brokers = response.data.brokers;

            //Process broker and agency
            $.each(brokers, function (index, broker) {
                broker["agency"] = response.data.agencies.find(x => x.id == broker.agency_id);
            });

            self.sale['brokers_detail'] = [];

            $.each(self.sale.brokers, function (index, broker) {
                let broker_role = broker.broker_role;
                broker = brokers.find(x => x.user_id == broker.broker_user_id);
                broker['role_name'] = self.SSEoiService.broker_roles.find(x => x.id == broker_role).name;
                broker['role_id'] = broker_role;
                self.sale.brokers_detail.push(broker);
            });

            //Get buyer agent
            self.sale["main_broker"] = self.sale.brokers_detail.find(x => x.role_id == 1);

            if (!self.sale.main_broker) {
                //If don't have buyer agent, get sales consultant
                self.sale.main_broker = self.sale.brokers_detail.find(x => x.role_id == 5);

                if (!self.sale.main_broker) {
                    //If don't have sales consultant, get team ic
                    self.sale.main_broker = self.sale.brokers_detail.find(x => x.role_id == 4);                    
                }
            }

            self.sale["eoi"] = response.data.eois.find(x => x.id == self.sale.eoi_id);
            self.sale["unit"] = response.data.units.find(x => x.id == self.sale.unit_id);

            /** WEB-2918 DMS: OTP Date - Add permissions **/
            self.selected_property_id = self.sale.unit.property_id;

            if (self.sale.unit_price_schedule && self.sale.unit_price_schedule.price) {
                self.sale.unit_listing_price = self.sale.unit_price_schedule.price;
            } else {
                self.sale.unit_listing_price = self.sale.unit.price;
            }
            self.brokersDetailCopy = angular.copy(self.sale.brokers_detail);
            self.brokersDetailCopy_copy = angular.copy(self.brokersDetailCopy);

            $.each(self.brokersDetailCopy,function (index,broker){
                self.addBrokerParams.push([broker.user_id,broker.role_id]);
            });

            // Get Property Questions
            self.getPropertyQuestions(self.sale.unit.property_id);

            url = 'properties/' + self.sale.unit.property_id;
            // NEW REQUIREMENT: SHOW DISCOUNT INFO -- WEB-784
            params = {
                'include': 'property_discounts, property_payment_plans',
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.sale['property'] = response.data.property;

                if( self.sale.property.settings && self.sale.property.settings.length ){
                    let payment_settings = self.SettingsService.getSetting(response.data.property.settings, 'payment_types');
                    if(payment_settings &&
                        payment_settings.value &&
                        payment_settings.value.includes(-1)){
                        self.is_payment_section_disabled = true;
                    }

                    let is_upload_doc_section_disabled_settings = self.SettingsService.getSetting(response.data.property.settings, 'buyer_identity_documents_disabled');
                    if(is_upload_doc_section_disabled_settings && is_upload_doc_section_disabled_settings.value){
                        self.is_upload_doc_section_disabled = is_upload_doc_section_disabled_settings.value;
                    }

                    let otp_spa_settings = self.SettingsService.getSetting(response.data.property.settings, 'otp_spa');
                    if(otp_spa_settings && otp_spa_settings.value === "NONE"){
                        self.is_otp_spa_doc_type_none = true;
                    }
                }

                // NEW REQUIREMENT: SHOW DISCOUNT INFO -- WEB-784
                // Prepare Discount info
                // REQUIREMENT CHANGED
                // https://showsuite.atlassian.net/browse/WEB-883
                self.prepareDiscountInfo();
                // if (!!self.sale.sale_discounts && !!self.sale.property.property_discounts) {
                //     $.each(self.sale.sale_discounts, function (index, discount) {
                //         let _discount = self.sale.property.property_discounts.find(x => x.id == discount.property_discount_id);
                //         if (_discount) {
                //             _discount.remarks = discount.remarks;
                //             if (self.sale.hasOwnProperty('discounts')) {
                //                 self.sale.discounts.push(_discount);
                //             } else {
                //                 self.sale.discounts = [];
                //                 self.sale.discounts.push(_discount);
                //             }

                //             let selected_unit = self.sale.unit;
                //             if (selected_unit) {
                //                 if (!selected_unit.hasOwnProperty("applied_discounts") || !selected_unit.applied_discounts) {
                //                     selected_unit.applied_discounts = [];
                //                 }
                //                 _discount.property_discount_id = discount.property_discount_id;
                //                 selected_unit.applied_discounts.push(_discount);
                //                 self.recalculateDiscount(selected_unit);
                //             }

                //         }
                //     });
                // }

                self.getOtpDocs();

                if(self.checkPermission('PROPERTY_COMMISSION_GET'))
                {
                    //Commissions & Incentives
                    self.getPropertyCommissions();
                }

                if(!!self.otp_documents && self.checkDocumentType() == "OTP"){
                    self.selected_otp_document = self.otp_documents[0].id;
                }
                if(!!self.spa_documents && self.checkDocumentType() == "SPA"){
                    self.selected_otp_document = self.spa_documents[0].id;
                }

                // Get agency for GST info
                url = 'agencies';
                let _params = {
                    property_id: self.sale.unit.property_id
                }
                self.SSHttpService.getAPIRequest(url, _params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if (response.data.agencies && response.data.agencies.length > 0) {
                        self.sale['agency'] = response.data.agencies.find(x => x.agency_id == self.sale.agency_id);
                    }
                });
                if(response.data.property){
                    self.property_type = response.data.property.type;
                    if (response.data.property.property_payment_plans && response.data.property.property_payment_plans.length > 0) {
                        let paymentPlan = response.data.property.property_payment_plans.find(x => x.payment_plan_id == self.sale.payment_plan_id);
                        if(paymentPlan){
                            self.sale.payment_plan = paymentPlans.find(x => x.id === paymentPlan.payment_plan_id);
                        }
                    }
                }
            });

            self.sale["other_documents"] = {};
            let buyer_declaration_form_counter = 1;
            self.sale.supporting_documents = [];
            // let first_other_document = true;
            //Process documents

            self.$timeout(function(){

                $.each(self.sale.documents, function (index, buyer_document) {
                    let temp_buyer = self.sale.buyers.find(x => x.sale_buyer_id == buyer_document.sale_buyer_id);
                    
                    //prepare preview document
                    if (!buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED 
                        && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS) {
                        self.regenerateParticularsPdf(buyer_document, function(response){
                            buyer_document["title"] = "Buyer Particulars";
                            self.sale.other_documents[buyer_document.document_kind] = buyer_document;
                        });
                    }

                    if (buyer_document.file_uri
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_USER_DOC
                        && buyer_document.document_kind != self.PROPERTY_DOCUMENT_KIND_OTHER
                        && temp_buyer
                    ) {
                        // Buyer IC/Passport etc.
                        url = 'sec/assets/presigned-url';
                        params = {
                            'model': buyer_document.type,
                            'id': buyer_document.id
                        };
                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            if (response instanceof Error) {
                                loading(false);
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            buyer_document["show_file_url"] = response.data.presigned_url;
                            self.$timeout(function(){
                                $(".zoom").magnify();
                            }, 1000);
                        });
                    } else if (buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_FORM
                        && buyer_document.document_kind != self.PROPERTY_DOCUMENT_KIND_OTHER
                    ) {
                        if (buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM
                            && self.sale.sale_buyers.length > 1
                        ) {
                            buyer_document["title"] = buyer_document.name + ' - ' + buyer_declaration_form_counter;
                            buyer_declaration_form_counter++;
                        } else {
                            buyer_document["title"] = buyer_document.name;
                        }
                        self.sale.other_documents[buyer_document.document_id ? buyer_document.document_id : buyer_document.id] = buyer_document;
                    } else if (buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED 
                        && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP) {
                        buyer_document["title"] = "OTP";
                        self.sale.other_documents[buyer_document.document_kind] = buyer_document;
                    } else if (buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED 
                        && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS) {
                        buyer_document["title"] = "Buyer Particulars";
                        self.sale.other_documents[buyer_document.document_kind] = buyer_document;
                    } else if (buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED 
                        && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER) {
                        buyer_document["title"] = buyer_document["name"];
                        self.sale.other_documents[buyer_document.id] = buyer_document;
                    }else if(buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED
                        && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_AML){
                            buyer_document["title"] = buyer_document["name"];
                            let document = self.findDocumentByKind(self.PROPERTY_DOCUMENT_KIND_AML, buyer_document.name);
                            if(document){
                                if(document.name == buyer_document.name ){
                                    let latestDocument = self.getLatestDocument(document, buyer_document);
                                    delete self.sale.other_documents[document.id];
                                    self.sale.other_documents[latestDocument.id] = latestDocument;
                                }else{
                                    self.sale.other_documents[buyer_document.id] = buyer_document;
                                }
                            }
                            else{
                                self.sale.other_documents[buyer_document.id] = buyer_document;
                            }
                    }else if (buyer_document.file_uri 
                        && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED) {
                        buyer_document["title"] = buyer_document["name"];
                        self.sale.other_documents[buyer_document.document_kind] = buyer_document;
                    } else if (buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_USER_DOC
                        && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_OTHER
                    ) {
                        // Other Supporting Documents Uploaded by Buyer
                        if (buyer_document.file_uri) {
                            let url = 'sec/assets/presigned-url';
                            let params = {
                                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                                'id': buyer_document.id
                            };

                            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                                if (response instanceof Error) {
                                    loading(false);
                                    self.SSAlertService.parseAndDisplayError(response);
                                    return;
                                }

                                buyer_document["show_file_url"] = response.data.presigned_url;
                                self.$timeout(function(){
                                    $(".zoom").magnify();
                                }, 1000);
                            });
                        }
                        self.sale.supporting_documents.push(buyer_document);
                    } else if (buyer_document.beneficiary_id) {
                      let beneficiary = self.sale.beneficiaries.find(x => x.id == buyer_document.beneficiary_id);

                      if (buyer_document.file_uri && beneficiary) {
                        let url = 'sec/assets/presigned-url';
                        let params = {
                            'model': self.ASSET_MODEL_SALE_DOCUMENT,
                            'id': buyer_document.id
                        };

                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            if (response instanceof Error) {
                                loading(false);
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            buyer_document["show_file_url"] = response.data.presigned_url; 
                            self.$timeout(function(){
                                $(".zoom").magnify();
                            }, 1000);
                        });

                        if (!beneficiary.hasOwnProperty("documents")) {
                            beneficiary["documents"] = {};
                        }
                        beneficiary["documents"][buyer_document.document_kind] = buyer_document;
                      }
                    } else if (buyer_document.non_buyer_payee_id) {
                      let non_buyer_payee = self.sale.non_buyer_payees.find(x => x.id == buyer_document.non_buyer_payee_id);

                      if (buyer_document.file_uri && non_buyer_payee) {
                        let url = 'sec/assets/presigned-url';
                        let params = {
                            'model': self.ASSET_MODEL_SALE_DOCUMENT,
                            'id': buyer_document.id
                        };

                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            if (response instanceof Error) {
                                loading(false);
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            buyer_document["show_file_url"] = response.data.presigned_url; 
                            self.$timeout(function(){
                                $(".zoom").magnify();
                            }, 1000);
                        });

                        if (!non_buyer_payee.hasOwnProperty("documents")) {
                            non_buyer_payee["documents"] = {};
                        }
                        non_buyer_payee["documents"][buyer_document.document_kind] = buyer_document;
                      }
                    } else {
                        buyer_document["show_file_url"] = "";
                    }

                    if (temp_buyer) {
                        temp_buyer.documents[buyer_document.document_kind] = buyer_document;
                    }

                });

                /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed **/
                if (!self.sale.other_documents || !Object.values(self.sale.other_documents).length) {
                    // If sale has no other_documents set all_docs_viewed flag as true
                    self.all_docs_viewed = true;
                }

                /** Set docs_processed to enable action buttons after documents processing is complete **/
                self.docs_processed = true;
            }, 2500);

            // self.$timeout(function() {
            //   self.changeDisplayDoc(self.sale.other_documents[Object.keys(self.sale.other_documents)[0]]);
            // }, 1000);

            //Process payments & instruments
            $.each(self.sale.payments, function (index, payment) {
                $.each(payment.instruments, function (i, instrument) {
                    if (instrument.file_uri) {
                        //prepare preview document
                        url = 'sec/assets/presigned-url';

                        params = {
                            'model': self.ASSET_MODEL_PAYMENT_INSTRUMENT,
                            'id': instrument.id
                        };
                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            if (response instanceof Error) {
                                loading(false);
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            instrument["show_file_url"] = response.data.presigned_url;
                            self.$timeout(function(){
                                $(".zoom").magnify();
                            }, 1000);
                        });
                    }

                    if (instrument.type == self.INSTRUMENT_TYPE_CHEQUE && !instrument.file_uri) {
                        self.payment_missing_document = true;
                    }
                });
                $('.datepicker').datepicker({
                    dateFormat: 'YYYY-MM-DD'
                });
            });

            //Process history
            if (self.sale.hasOwnProperty("history") && self.sale.history.length > 0) {
                let filtered_remarks = [];

                $.each(self.sale.history, function (index, history_individual) {
                    let users = response.data.users;

                    let status_obj = self.sale_statuses.find(x => x.id == history_individual.status);
                    history_individual["status_name"] = status_obj ? status_obj.name : null;

                    let _user = users.find(x => x.id === history_individual.created_by);
                    history_individual["user"] = _user ? _user : {}; // Set not null
                    let broker_detail = self.sale.brokers_detail.find(x => x.user_id == history_individual.created_by);
                    history_individual["user"]["role_name"] = broker_detail ? broker_detail.role_name : "Team IC";

                    filtered_remarks.push(history_individual);
                });

                if (filtered_remarks.length > 0) {
                    self.sale["filtered_remarks"] = filtered_remarks;
                }
            }

            let path_name = location.pathname;
            let array_url = path_name.split("/");

            if (array_url[array_url.length - 1] == "summary") {
                let otp_document = self.sale.documents.find(x => x.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP);

                if (otp_document) {
                    self.has_otp_document = true;

                    self.$timeout(function () {
                        self.changeDisplayDoc(otp_document, self.TYPE_DOCUMENT_VIEW);
                    }, 3000);
                }
            } else if (array_url[array_url.length - 1] == "review") {
                self.$timeout(function () {
                    self.changeDisplayDoc(self.sale.other_documents[Object.keys(self.sale.other_documents)[0]]);
                }, 3000);
            }

            // Instructions to Lawyer
            $('#requestedSpaIssueDate').datepicker({
                dateFormat: 'dd/mm/yy'
            });
            if (self.sale.requested_spa_issue_date) {
                self.sale.requested_spa_issue_date = moment(self.sale.requested_spa_issue_date).format('DD/MM/YYYY');
            }

            // https://showsuite.atlassian.net/browse/WEB-2200
            // Booking Fee Calculation as per Selected Payment Plan
            try{
                if(self.sale.payment_plans && self.sale.payment_plans.length > 0 && self.sale.payment_plans[0].payment_plan_clauses){
                    let clause = self.sale.payment_plans[0].payment_plan_clauses.find(x => x.payment_type == self.PAYMENT_TYPE_01_BOOKING_FEE);
                    if(clause && clause.amount_percentage){
                        self.booking_fee_percentage = clause.amount_percentage;
                    }
                } 
            }
            catch(ex){
                console.log(ex);
            }

            self.getDeveloperUsers();
            self.getSaleUnitDetails();
            self.getSalesOccupier();
        });
    }

    regenerateParticularsPdf(document, callback){
        const self = this;

        if(!document) return;

        let url = 'sec/developer/sales/'+ self.sale.id +'/re-generate-bpf';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(
                    response
                );
                return;
            }

            if(callback){
                callback(response);
            }
        });
    }

    checkBuyerDocuments(){
        const self = this;

        if(!self.sale || !self.sale.buyers || !self.sale.buyers.length) { return false }

        self.sale.buyers.forEach( (buyer) => {
            // For Corporate sale only need to check document against Authorised Officer
            if(buyer.type === self.BUYER_TYPE_INDIVIDUAL){
                if (buyer.hasOwnProperty("documents")) {
                    if (buyer.individual.identity_type !== self.IDENTITY_TYPE_FOREIGNER) {
                        if (!buyer.documents[self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT] || !buyer.documents[self.PROPERTY_DOCUMENT_KIND_NRIC_BACK]) {
                            self.buyer_document_missing = true;
                        }
                    } else if (!buyer.documents[self.PROPERTY_DOCUMENT_KIND_PASSPORT]) { // Foreigner Buyer
                        self.buyer_document_missing = true;
                    }
                } else {
                    self.buyer_document_missing = true;
                }
            }
        });
    }

    getSalesNonBuyerPayees() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale.id + '/non-buyer-payees';
        let params = {
            'include': 'individual, company, primary_address, email_contact, phone1_contact, phone2_contact, documents',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.sale_non_buyer_payees && response.data.sale_non_buyer_payees.length > 0) {
                self.sale.non_buyer_payees = response.data.sale_non_buyer_payees;

                self.sale.non_buyer_payees = _.sortBy(self.sale.non_buyer_payees, 'order');

                $.each(self.sale.non_buyer_payees, function(index, nonBuyerPayee) {
                    if (nonBuyerPayee.data && typeof nonBuyerPayee.data == "string") {
                        nonBuyerPayee.data = JSON.parse(nonBuyerPayee.data);
                        nonBuyerPayee.processed_data = nonBuyerPayee.data;
                    }

                    if(!nonBuyerPayee.order){
                        nonBuyerPayee.order = index + 1;
                    }
                });

                /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
                self.SSEoiService.nonBuyerPayees = self.sale.non_buyer_payees || null;

                /** WEB-2901 FATF Black List - Indications **/
                self.checkBuyersAgainstFatfList("NON_BUYER_PAYEE");
            }
        });
    }

    checkNonBuyerDocuments(nonBuyerPayee){
        const self = this;

        if(!nonBuyerPayee) { return false }

        if(nonBuyerPayee.type === self.BUYER_TYPE_INDIVIDUAL){
            if (nonBuyerPayee.hasOwnProperty("sale_documents")) {
                if (nonBuyerPayee.individual.identity_type !== self.IDENTITY_TYPE_FOREIGNER) {
                    if (!nonBuyerPayee.documents[self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT] || !nonBuyerPayee.documents[self.PROPERTY_DOCUMENT_KIND_NRIC_BACK]) {
                        self.buyer_document_missing = true;
                    }
                } else if (!nonBuyerPayee.documents[self.PROPERTY_DOCUMENT_KIND_PASSPORT]) {
                    self.buyer_document_missing = true;
                }
            } else {
                self.buyer_document_missing = true;
            }
        }
    }

    findDocumentByKind(documentKind, name){
        const self = this;
        for (let documentId in self.sale.other_documents) {
            if (self.sale.other_documents.hasOwnProperty(documentId)) {
              let document = self.sale.other_documents[documentId];
              if (document.document_kind === documentKind && document.name == name) {
                return document;
              }
            }
          }
          return null;
    }

    getLatestDocument(document1, document2) {
        const timestamp1 = new Date(document1.updated_at);
        const timestamp2 = new Date(document2.updated_at);
      
        if (timestamp1 > timestamp2) {
          return document1;
        } else {
          return document2;
        }
    }

    updateQuestionAnswers(callback) {
        const self = this;

        if(!self.questions || !self.questions.length){ return false; }

        let answers = self.SSEoiService.getQuestionAnswers(self.questions);
        let url = 'sec/sales/' + self.sale.id + '/questions-answers/save-multiple';
        let params = {
            question_answers: JSON.stringify(answers),
            entity_type: self.QUESTION_ENTITY_TYPE_DEVELOPER
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback();
            }
        });
    }


    getSaleUnitDetails() {
        const self = this;

        let url = 'properties/' + self.sale.property_id + '/units/' + self.sale.unit_id;

        let param = {
            'include': 'selections'
        };

        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.unit_selections = response.data.selections;

            url = 'sec/sales/' + self.sale.id + '/selections/payments';
            param = {
              'include': 'instruments'
            };

            self.SSHttpService.getAPIRequest(url, param).then(function (response) {
                self.unit_loading = false;
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.sale_selection_payments = response.data.sale_selection_payments;

                //Rearrange the selection order
                if (self.unit_selections && self.unit_selections.length > 0) {
                    self.unit_selections.sort(function (a, b) {
                      return a.order - b.order;
                    });
                }

                self.display_sale_selection_payments = [];

                $.each(self.unit_selections, function(index, selection) {
                    selection.sale_selection = self.sale.sale_selections.find(x => x.selection_id === selection.id);

                    if (selection.sale_selection) {
                      selection.sale_payment = self.sale_selection_payments.find(x => x.sale_selection_id == selection.sale_selection.id);

                      if (selection.sale_payment) {
                        self.display_sale_selection_payments.push(selection);
                        $.each(selection.sale_payment.instruments, function(i, instrument) {
                          if (instrument.cheque_date) {
                              instrument.cheque_date = moment(self.parseDate(instrument.cheque_date)).format('YYYY-MM-DD');
                          }

                          if (instrument.bank_in_date) {
                              instrument.bank_in_date = moment(self.parseDate(instrument.bank_in_date)).format('YYYY-MM-DD');
                          }
                          if (instrument.file_uri) {
                            let url = 'sec/assets/presigned-url';
                            let params = {
                              'model': SHOWSUITE.ASSET_MODEL_SELECTION_PAYMENT_INSTRUMENT,
                              'id': instrument.id
                            };
                            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                              if (response instanceof Error) {
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                              }

                                instrument.show_file_url = response.data.presigned_url;
                                self.$timeout(function(){
                                    $(".zoom").magnify();
                                }, 1000);
                            });  
                          }
                        });
                      }
                    }

                    //Prepare to setup choices
                    if (selection.type == SHOWSUITE.QUESTION_TYPE_SELECT || selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX || selection.type == SHOWSUITE.QUESTION_TYPE_RADIO) {
                        selection["formatted_choices"] = selection.choices;

                        if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                            let formatted_choices = angular.copy(selection.formatted_choices);
                            selection.formatted_choices = [];
                            $.each(formatted_choices, function (j, choice) {
                                let new_choice = {};
                                new_choice["label"] = choice;
                                new_choice["answer"] = false;
                                selection.formatted_choices.push(new_choice);
                            });
                        }

                        if (selection.sale_selection && selection.sale_selection.selection_answer_text) {
                            if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                                let answered_choices = self.SSEoiService.getFormattedAnswer(selection.sale_selection.selection_answer_text)

                                $.each(answered_choices, function(i, choice) {
                                    let found_choice = selection.formatted_choices.find(x => x.label == choice);

                                    if (found_choice) {
                                        found_choice.answer = true;
                                    }
                                });

                                selection.sale_selection.formatted_answer = self.SSEoiService.getFormattedAnswer(selection.sale_selection.selection_answer_text);

                                if (selection.sale_selection.formatted_answer && selection.sale_selection.formatted_answer.length > 0) {
                                    selection.sale_selection.formatted_answer = selection.sale_selection.formatted_answer.join(", ");
                                    self.disable_selections_email = true;
                                }
                            } else {
                                selection.answer_text = self.SSEoiService.getFormattedAnswer(selection.sale_selection.selection_answer_text, true);
                                selection.sale_selection.formatted_answer = selection.answer_text;
                            }
                        } else {
                            // Auto select default answer
                            if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                                try {
                                    let default_choices = JSON.parse(selection.default_choice)

                                    $.each(default_choices, function (i, choice) {
                                        let found_choice = selection.formatted_choices.find(x => x.label == choice);

                                        if (found_choice) {
                                            found_choice.answer = true;
                                        }
                                    });
                                } catch (ex) {
                                    console.log("Error parsing selection's 'default_choice.");
                                }
                            } else {
                                if (selection.sale_selection && selection.sale_selection.default_choice) {
                                  selection.answer_text = self.SSEoiService.getFormattedAnswer(selection.sale_selection.default_choice, true);
                                }
                            }
                        }
                    }
                });
            });
        });
      }

        getSalesOccupier() {
        const self = this;

        let url = 'sec/developer/sales/' + self.data.sale_id + '/occupiers';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.saleOccupiers && response.data.saleOccupiers.length > 0) {
                self.sale_occupiers = response.data.saleOccupiers;

                self.sale_occupiers = _.sortBy(self.sale_occupiers, 'order');

                $.each(self.sale_occupiers, function(index, occupier) {
                    if (occupier.data && typeof occupier.data == "string") {
                        occupier.data = JSON.parse(occupier.data);
                    }
                });
            }
        });
    }

    // prepareDiscountInfo(){
    //     const self = this;

    //     try{
    //       // Prepare Discount info
    //       if(!!self.sale.sale_discounts && !!self.sale.property.property_discounts){

    //         let property_discounts = [];

    //         $.each(self.sale.sale_discounts, function(index, discount){
    //           let _discount = self.sale.property.property_discounts.find(x => x.id == discount.property_discount_id);
    //           // Copy fields (which are not available) from sale discount object
    //           _discount.remarks = discount.remarks;
    //           _discount.type_name = self.SSConfigService.getDiscountTypeName(_discount.type);
    //           _discount.property_discount_id = discount.property_discount_id;
    //           property_discounts.push(_discount);
    //         });

    //         // Sort discounts on the basis of order
    //         self.sale.sale_discounts = _.sortBy(property_discounts, 'order');

    //         // Make groups for discount to be applied
    //         // 1st group which has 'calculat_list_price' true
    //         let group_1 = [];

    //         // 2nd group which has 'calculat_list_price' false
    //         let group_2 = [];

    //         // 3rd group which can't affect List/Selling price
    //         let group_3 = [];

    //         $.each(self.sale.sale_discounts, function(index, _discount){
             
    //           if(_discount.calculate_on_list_price && self.isInstantDiscountType(_discount.type)){
    //             group_1.push(_discount);
    //           }
    //           else if(!_discount.calculate_on_list_price && self.isInstantDiscountType(_discount.type)){
    //             group_2.push(_discount);
    //           }
    //           else{
    //             group_3.push(_discount);
    //           }
              
    //         });

    //         let unit = self.sale.unit;

    //         let final_sale_price = unit.price;

    //         // Calculate respective discount for group 1
    //         // Calculate this on 'list_price'
    //         $.each(group_1, function(index, discount_obj){

    //           final_sale_price = self.calculateDiscount(discount_obj, final_sale_price);

    //         });

    //         // Calculate respective discount for group 2
    //         $.each(group_2, function(index, discount_obj){

    //           final_sale_price = self.calculateDiscount(discount_obj, final_sale_price);

    //         });

    //         self.sale.unit.final_sale_price = final_sale_price;

    //         let other_sale_price = final_sale_price;

    //         // Calculate respective discount for group 3
    //         $.each(group_3, function(index, discount_obj){

    //           self.calculateDiscount(discount_obj, other_sale_price);

    //         });
    //       }
    //     }
    //     catch(ex){
    //       console.log(ex);
    //     }
    // }

      getDiscountValue(discount){
    const self = this;

    if(!discount){
      return '--';
    }

    if (discount.amount_type == self.VALUE_TYPE_PERCENTAGE) {
      return discount.amount_value + '%';
    } else if (discount.amount_type == self.VALUE_TYPE_AMOUNT) {
      return self.SSAppService.getFormattedAmountWithDecimal(discount.amount_value);
    }
  }

    prepareDiscountInfo(){
        const self = this;

        try{
          // Prepare Discount info
          if(!!self.sale.sale_discounts && !!self.sale.property.property_discounts){

            if (!self.sale.hasOwnProperty('discounts') || !self.sale.discounts){
              self.sale.discounts = [];
            }
            
            // Get formatted discounts
            let sale_discounts = self.SSEoiService.getDiscountInfo(self.sale.sale_discounts, self.sale.property.property_discounts, self.sale.unit.price);

            self.sale.discounts = sale_discounts.discounts;
            self.sale.unit.final_sale_price = sale_discounts.final_sale_price; 

            // let property_discounts = [];

            // $.each(self.sale.sale_discounts, function (index, discount) {

            //   let _discount = self.sale.property.property_discounts.find(x => x.id == discount.property_discount_id);
            //   // Copy fields (which are not available) from sale discount object
            //   _discount.remarks = discount.remarks;
            //   _discount.type_name = self.SSConfigService.getDiscountTypeName(_discount.type);
            //   _discount.property_discount_id = discount.property_discount_id;
            //   property_discounts.push(_discount);

            // });

            // // Sort discounts on the basis of order
            // self.sale.sale_discounts = _.sortBy(property_discounts, 'order');
            // let unit = self.sale.unit;

            // let list_price = unit.price;
            // let nett_selling_price = unit.price;
            // let final_sale_price = unit.price;

            // // First calculat STANDARD DISCOUNT
            // // nett_selling_price is only meant to be calculated from STANDARD DISCOUNT
            // let standard_discount = property_discounts.find(x => x.type == self.DISCOUNT_TYPE_STANDARD);
            // if(standard_discount){
            //     nett_selling_price = self.calculateDiscount(standard_discount, list_price);
            // }
            // if (!self.sale.hasOwnProperty('discounts') || !self.sale.discounts){
            //   self.sale.discounts = [];
            // }

            // if(standard_discount){
            //     self.sale.discounts.push(standard_discount);
            // }

            // // Remove STANDARD DISCOUNT
            // property_discounts = $.grep(property_discounts, function(obj){
            //     return obj.type != self.DISCOUNT_TYPE_STANDARD;
            // });

            // let staff_discount_value = 0;
            // // Now calculat STAFF DISCOUNT
            // let staff_discount = property_discounts.find(x => x.type == self.DISCOUNT_TYPE_STAFF);
            // if(staff_discount){
            //     staff_discount_value = self.getDiscountedAmount(staff_discount, list_price);
            //     // push to applied_discounts
            //     self.sale.discounts.push(staff_discount);
            // }
            
            // // Remove STAFF DISCOUNT
            // property_discounts = $.grep(property_discounts, function(obj){
            //     return obj.type != self.DISCOUNT_TYPE_STAFF;
            // });

            // // ----------------------------------------

            // let discounted_price = 0;
            // // Calculate remaining discounts
            // // Calculate all discounts (and sum up) then at the end subtract it from 'nett_selling_price'
            // $.each(property_discounts, function(index, discount){
            //     if(self.isInstantDiscountType(discount.type)){
            //         discounted_price += self.getDiscountedAmount(discount, nett_selling_price);
            //     }
            //     else{
            //         self.calculateDiscount(discount, unit.price);
            //     }
            //     // push to applied_discounts
            //     self.sale.discounts.push(discount);
            // });

            // let _price = discounted_price + staff_discount_value;

            // final_sale_price = nett_selling_price - _price;

            // self.sale.unit.final_sale_price = final_sale_price; 
          }
        }
        catch(ex){
          console.log(ex);
        }
    }

    // calculateDiscount(discount, price) {
    //     const self = this;

    //     let discount_value = 0;
    //     if (discount.amount_type == self.VALUE_TYPE_PERCENTAGE) {
    //         discount_value = (price * discount.amount_value) / 100;
    //     } else if (discount.amount_type == self.VALUE_TYPE_AMOUNT) {
    //         discount_value = discount.amount_value;
    //     }

    //     price = price - discount_value;

    //     discount.discount_value = discount_value;

    //     return price;
    // }

    // getDiscountedAmount(discount, price){
    //     const self = this;

    //     let discount_value = 0;
    //     if (discount.amount_type == self.VALUE_TYPE_PERCENTAGE) {
    //         discount_value = (price * discount.amount_value) / 100;
    //     } else if (discount.amount_type == self.VALUE_TYPE_AMOUNT) {
    //         discount_value = discount.amount_value;
    //     }

    //     discount.discount_value = discount_value;
    //     return discount_value;
    // }

    getDiscountValue(discount){
        const self = this;

        if(!discount){
          return '--';
        }

        if (discount.amount_type == self.VALUE_TYPE_PERCENTAGE) {
          return discount.amount_value + '%';
        } else if (discount.amount_type == self.VALUE_TYPE_AMOUNT) {
          return self.SSAppService.getFormattedAmountWithDecimal(discount.amount_value);
        }
    }

    // isInstantDiscountType(type){
    //     const self = this;

    //     if(type == self.DISCOUNT_TYPE_STAFF
    //       || type == self.DISCOUNT_TYPE_STANDARD 
    //       || type == self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE 
    //       || type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE 
    //       || type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER
    //       || type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL){
    //       return true;
    //     }
    //     else{
    //       return false;
    //     }
    // }

    showEditableBankinDate() {
        const self = this;

        self.bank_in_date_error = false;
        self.editBankinDate = true;

        // UPDATE DATEPICKER CALENDAR
        $('.datepicker').datepicker({
            dateFormat: 'yy-mm-dd'
        });
    }

    updateBankinDate(payment, instrument) {
        const self = this;

        if (!self.bank_in_date) {
            self.bank_in_date_error = true;
            return;
        } else {
            //Validate bank in date
            if (instrument.hasOwnProperty("cheque_date") && instrument.cheque_date != null) {
                let temp_bank_in_date = moment(self.bank_in_date, 'YYYY-MM-DD');
                let temp_cheque_date = moment(instrument.cheque_date, 'YYYY-MM-DD');

                if (temp_bank_in_date.isBefore(temp_cheque_date)) {
                    self.SSAlertService.danger("Error!", "Bank in date cannot be earlier than cheque date.");
                    self.bank_in_date_error = true;
                    return;
                }
            }

            self.bank_in_date_error = false;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (confirmationStatus) {
                self._updateBankinDate(payment, instrument);
            }
        );
    }

    _updateBankinDate(payment, instrument) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale.id + '/payments/' + payment.id + '/instruments/' + instrument.id;
        let params = angular.copy(instrument);
        params.bank_in_date = self.SSDateService.formateWithTimeAsNoon(self.bank_in_date);

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data) {
                try {
                    let _instrument = response.data.payment.instruments.find(x => x.id == instrument.id);
                    angular.merge(instrument, _instrument);
                    self.editBankinDate = false;
                } catch (ex) {
                    console.log(ex);
                }
            }
        });
    }

    downloadPic(file_obj, model_type) {
        const self = this;

        model_type = model_type ? model_type : file_obj.type;

        //Retrieve new pre-signed url to avoid timeout issue from S3
        let url = 'sec/assets/presigned-url';
        let params = {
            'model': model_type,
            'id': file_obj.id
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            window.open(response.data.presigned_url, '_blank');
        });
    }

    showFullscreen($event) {
        const self = this;

        if (!self.Fullscreen.isEnabled()) {
            self.toggleFullscreen($event);
        }
    }

    closeFullscreen() {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.toggleFullscreen();
        }
    }

    toggleFullscreen($event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
            $('img').css({"width": "100%", "height": ""});
        } else {
            if (!$event) return;

            if ($event.currentTarget.tagName == "A") {
                let image = $event.target.parentNode.parentNode.previousElementSibling;

                if (image) {
                    self.Fullscreen.enable(image);
                    $('img').css({"width": "auto", "height": "500px"});
                }
            } else if ($event.currentTarget.tagName == "IMG") {
                self.Fullscreen.enable($event.currentTarget);
                $('img').css({"width": "auto", "height": "500px"});
            }
        }
    }

    changeDisplayDoc(other_document) {
        const self = this;

        if (!other_document) return;

        /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed **/
        other_document.is_viewed = true; // Set flag true if a document is viewed
        self.checkAllDocsViewed(); // Check if user viewed all documents

        if(other_document.pdf_generation_required){
            self.regeneratePdf(other_document, function(response){
                loading(false);
                if(response && response.data){
                    self.showDocument(response.data.sale_document);
                }
            });
        } else {
            self.showDocument(other_document);
        }
    }

    showDocument(other_document){
        const self = this;

        $('#document_container').empty();

        self.display_doc = other_document;

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': self.ASSET_MODEL_SALE_DOCUMENT,
            'id': other_document.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                // self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.presigned_url)
                $('#document_container').html('<iframe style="width:100%; height:100%;" src="' + response.data.presigned_url + '"></iframe>');
        });
    }

    regeneratePdf(document, callback){
        const self = this;

        if(!document) return;

        let url = 'sec/sales/'+ self.sale.id +'/documents/'+ document.id +'/re-generate-pdf';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(
                    response
                );
                return;
            }

            if(callback){
                callback(response);
            }
        });
    }

    viewEnlargePic(file_path) {
        const self = this;

        let win = window.open(file_path, '_blank');
        win.focus();
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = 'sec/developer/properties';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;

            self.$timeout(function () {
                $("select.dashboard-select#property-select").niceSelect('update');
            });

            self.retrieveApplications();
        });
    }

    onAcceptConfirm(send_email) {
        const self = this;

        if(self.questions && self.questions.length){
            let remarksQuestion = self.questions.find(q => q.marker == 90);
            let remarksMaxLength = self.SSConfigService.getAmlRiskAssessmentRemarksMaxLength();
            if (remarksQuestion && remarksQuestion.answer_text && remarksQuestion.answer_text.length > remarksMaxLength) {
                remarksQuestion.error = "Only " + remarksMaxLength + " characters are allowed for remarks.";
                return;
            }

            if(self.SSEoiService.validateQuestionAnswers(self.questions)){
                // Update question answers
                self.updateQuestionAnswers(function () {
                    self.$timeout(function () {
                        self._onAcceptConfirm(send_email); // Mark sale Approved
                    });
                });
            }
        } else {
            // If no questions then proceed with confirm
            self._onAcceptConfirm(send_email);
        }
    }

    _onAcceptConfirm(send_email) {
        const self = this;

        var booking_fee = {};
        var total_booking_fee = 0;

        self.actual_booking_fee = 0;
        self.currentSale = self.sale;

        self.hideModals();

        let requestedSpaIssueDate = null;
        if (self.sale.requested_spa_issue_date) {
            let res = self.otp_date.split("/", 3);
            requestedSpaIssueDate = res[2] + '-' + res[1] + '-' + res[0];
            //requestedSpaIssueDate = moment(self.sale.requested_spa_issue_date).utc().format('YYYY-MM-DD');
        }

        let url = 'sec/developer/sales/' + self.sale.id + '/status';
        let params = {
            'status': self.SALE_STATUS_APPROVED,
            'remarks': self.sale.remarks,
            'pp_form_remarks': self.sale.pp_form_remarks,
            'send_email': send_email,
            'agency_commission_value': self.sale.agency_commission_value,
            'broker_incentives_value': self.sale.broker_incentives_value,
            'agency_commission_type': self.sale.agency_commission_type,
            'broker_incentives_type': self.sale.broker_incentives_type,
            'broker_incentives_gst_inclusive': self.sale.broker_incentives_gst_inclusive,
            'agency_commission_gst_inclusive': self.sale.agency_commission_gst_inclusive,
            'remarks_for_lawyer': self.sale.remarks_for_lawyer,
            'requested_spa_issue_date': requestedSpaIssueDate
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.sale.status = self.SALE_STATUS_APPROVED;
            self.unable_action = true;
            self.SSAlertService.success('Success!', 'Sale is approved successfully.');

            // Check booking Fee 5% before OTP generation
            jQuery.each(self.sale.payments, function (i, payments) {
                if (payments.type == self.PAYMENT_TYPE_01_BOOKING_FEE) {
                    booking_fee = payments;
                    return false;
                }
            });

            self.actual_booking_fee = booking_fee.due_amount;
            // self.actual_booking_fee = Math.round((self.sale.price * (self.booking_fee_percentage/100)) * 100) / 100;

            if (booking_fee.amount) {
                total_booking_fee = booking_fee.amount;
            }

            if (total_booking_fee < self.actual_booking_fee) {
                $('#developerSaleApplicationBookingfeeAlertModal').modal('show');
                return;
            }
            self.developerUser = null;
            self.developerUserError = null;

            if(self.is_otp_spa_doc_type_none){
                self.onRedirectBackToListing();
            } else{
                /** WEB-2871 DMS: Generate OTP popup doesn't show Document's dropdown
                 * Need to pre-select developerUser if only one in list **/
                if(self.developer_users && self.developer_users.length === 1 && self.developer_users[0].email){
                    self.developerUser = [];
                    self.developerUser[self.developer_users[0].email] = true
                }

                self.showOTPModal = true;
                $('#developerSaleApplicationOTPModal').modal('show');
            }
        });

    }

    onOTP() {
        const self = this;

        self.hideModals();
        self.developerUser = null;
        self.developerUserError = null;
        self.showOTPModal = true;
        $('#developerSaleApplicationOTPModal').modal('show');
    }

    onRejectConfirm() {
        const self = this;

        self.hideModals();
        let url = 'sec/developer/sales/' + self.sale.id + '/status';
        let params = {
            'status': self.SALE_STATUS_REJECTED,
            'remarks': self.sale.remarks
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.sale.status = self.SALE_STATUS_REJECTED;
            self.unable_action = true;
            self.SSAlertService.success('Success!', 'Sale is rejected successfully.');
            self.$timeout(function () {
                self.onRedirectBackToListing();
            }, 1000);
        });
    }

    onGenerateOTP(send_email) {
        const self = this;

        if (self.edit_otp) {
            // Open OTP in editor
            self.$window.location.href = '/developer/sales/' + self.data.sale_id + '/editotp';
        } else {
            self.generateOTP(send_email);
        }
    }

    generateOTP(send_email) {
        const self = this;

        /** WEB-2871 DMS: Generate OTP popup doesn't show Document's dropdown
         * WEB-2811 AMS/DMS : AUS country support
         * Need to support SPA Signing by multiple developer users.
         * by allowing user to select multiple Developer Users when generating SPA **/
        let developerUserIdList = "";
        try{
            /** Get comma separated list of Selected Developer User Id(s) **/
            if(self.developerUser){
                developerUserIdList = self.developer_users
                    .filter(function (u) { return self.developerUser[u.email] })
                    .map( function(fu) { return fu.id })
                    .join();
            }
        }catch (e){
            console.error("An error occurred parsing Developer User list,")
        }

        if(self.checkDocumentType() == "SPA" && !developerUserIdList){
            self.developerUserError = "Please Select a Developer";
            return;
        }
        let url = "";
        if(self.checkDocumentType() == "SPA"){
            url = 'sec/developer/sales/' + self.sale.id + '/generate-spa';
		}
        if(self.checkDocumentType() == "OTP"){
            url = 'sec/developer/sales/' + self.sale.id + '/generate-otp';
		}
        let params = {
            'send_email': send_email,
            'otp_date': self.SSDateService.formateWithTimeAsNoon(self.otp_date),
            'document': self.selected_otp_document,
            'timezone': self.SSDateService.getLocalTimezone()
        };
        if(self.checkDocumentType() == "SPA"){
			params['developer_user_id'] = developerUserIdList;
		}

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.hideModals();
                return;
            }

            let sale_document = response.data.sale_document;

            // self.sale.status = self.SALE_STATUS_OTP;
            // self.sale.documents.push(sale_document);

            // If 'file_uri != null' then document already signed
            if(sale_document && sale_document.file_uri){
                self.openDocument(sale_document);
                self.hideModals();
            } 
            else if(sale_document){
                let documentSignee = sale_document.document.document_signees[0];
                let _url = 'pub/documents/' + sale_document.document.id + '?signee_token=' + documentSignee.token + '&__sp=1&__email=1';
                _url = self.SSHttpService.getApiURL(_url);

                window.open(_url, '_blank');

                self.documentSigneeLoading = true;
                self.pingDocument(sale_document, documentSignee);
            }

            /** WEB-2871 DMS: Generate OTP popup doesn't show Document's dropdown
             * In case of SPA server responds with sale_documents instead of sale_document
             * sale_documents contain list of document signee **/
            if(self.checkDocumentType() == "SPA"){
                self.SSAlertService.success('Success!', 'SPA is generated successfully.');
            }

            self.hideModals();

        });
    }

    pingDocument(saleDocument, documentSignee) {
        const self = this;

        let url = 'sec/sales/' + saleDocument.sale_id + '/documents/' + saleDocument.id;

        self.SSHttpService.getAPIRequest(url).then(
            function (response) {
                if (response instanceof Error) {                    
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                let returned_signee = response.data.sale_document.document.document_signees.find(x => x.id === documentSignee.id);

                if (returned_signee) {
                    documentSignee.signature_file = returned_signee.signature_file;
                }

                //Successfully get the document object
                if (response.data.sale_document.file_uri == null) {
                    self.timeout_promise = self.$timeout(function () {
                        self.pingDocument(saleDocument, documentSignee);
                    }, 5000); // 5 sec delay
                } else {
                    saleDocument.file_uri = response.data.sale_document.file_uri;
                    self.documentSigneeLoading = false;
                    self.openDocument(saleDocument);
                }
            }
        );
    }

    openDocument(sale_document){
        const self = this;

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': self.ASSET_MODEL_SALE_DOCUMENT,
            'id': sale_document.id
        };
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Open OTP in new tab
            window.open(response.data.presigned_url, '_blank');
            self.SSAlertService.success('Success!', 'OTP is generated successfully.');
            self.onRedirectBackToListing();
        });
    }

    onRedirectBackToListing() {
        const self = this;

        self.hideModals();

        // WEB-4375: hand the review lock back before navigating away, as a
        // beacon — an $http POST issued immediately before a location change
        // is routinely cancelled by the navigation.
        self.releaseSaleLock('Left sale review page', true);

        // Redirect back
        self.$window.location.href = '/developer/sales/applications';
    }


    returnSales() {
        const self = this;

        self.return_remarks = '';
        self.return_sale_status = null;
        self.select_status_error = null;

        $('#returnSalesRemarksModal').modal('show');
    }

    _returnSales(sale) {
        const self = this;

        self.select_status_error = null;

        if(!self.return_sale_status){
            self.select_status_error = "Please select an option to proceed.";
            return;
        }

        if (!self.parameters){
            return;
        }

        let url = 'sec/developer/sales/' + self.parameters.sale_id + '/return';
        let params = {
            'saleId': self.parameters.sale_id,
            'remarks': self.return_remarks,
            'status': self.return_sale_status
        };

        $('#returnSalesRemarksModal').modal('hide');

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.returnStatus = response.data.sale;
            sale.status = self.returnStatus.status;
            self.SSAlertService.success('Success!', 'Sale Return updated successfully.');
        });
    }

    onAccept() {
        const self = this;

        // Validate remarks characters
        if (self.sale.remarks && self.sale.remarks.length > 500) {
            self.SSAlertService.danger("Error!", "Remarks cannot be more than 500 characters!");
            return;
        }
        // Validate pp form remarks characters
        if (self.sale.pp_form_remarks && self.sale.pp_form_remarks.length > 500) {
            self.SSAlertService.danger("Error!", "PP Form Remarks cannot be more than 500 characters!");
            return;
        }

        /** WEB-2784 DMS : Review Sale page issues
         * Check missing documents on Accept button click **/
        self.checkBuyerDocuments();
        $.each(self.sale.non_buyer_payees, function(index, nonBuyerPayee) {
            self.checkNonBuyerDocuments(nonBuyerPayee);
        })

        if ((self.buyer_document_missing && self.is_upload_doc_section_disabled.buyers !== 1) ||
            (self.payment_missing_document && !self.is_payment_section_disabled) ) {
            self.hideModals();
            self.showDocumentUploadSkip = true;
            $('#documentUploadSkipModal').modal({
                show: true,
                backdrop: 'static',
                keyboard: false
            });
            return;
        }
        self.hideModals();

        self.showAccept = true;
        $('#developerSaleApplicationAcceptModal').modal('show');
    }

    saveSalePrice() {
        const self = this;

        self.hideModals();
        self.showAccept = true;
        $('#developerSalePriceAcceptModal').modal('show');
    }

    onReject(sale) {
        const self = this;

        //Validate remarks characters
        if (self.sale.remarks && self.sale.remarks.length > 500) {
            self.SSAlertService.danger("Error!", "Remarks cannot be more than 500 characters!");
            return;
        }

        self.hideModals();

        self.showReject = true;
        $('#developerSaleApplicationRejectModal').modal('show');
    }

    hideModals() {
        const self = this;

        self.showReview = false;
        self.showAccept = false;
        self.showReject = false;
        self.showAgent = false;
        self.showBuyer = false;
        self.showOTPModal = false;
        self.showDocumentUploadSkip = false;

        if ($('#developerSaleApplicationReviewModal').is(':visible')) $('#developerSaleApplicationReviewModal').modal('hide');
        if ($('#developerSaleApplicationAcceptModal').is(':visible')) $('#developerSaleApplicationAcceptModal').modal('hide');
        if ($('#developerSaleApplicationRejectModal').is(':visible')) $('#developerSaleApplicationRejectModal').modal('hide');
        if ($('#developerSaleApplicationAgentModal').is(':visible')) $('#developerSaleApplicationAgentModal').modal('hide');
        if ($('#developerSaleApplicationBuyerModal').is(':visible')) $('#developerSaleApplicationBuyerModal').modal('hide');
        if ($('#developerSaleApplicationOTPModal').is(':visible')) $('#developerSaleApplicationOTPModal').modal('hide');
        if ($('#developerSalePriceAcceptModal').is(':visible')) $('#developerSalePriceAcceptModal').modal('hide');

        if ($('#AddCommissionModal').is(':visible')) $('#AddCommissionModal').modal('hide');
        if ($('#documentUploadSkipModal').is(':visible')) $('#documentUploadSkipModal').modal('hide');
        if ($("#paymentDetailsInfo").is('visible')) $('#paymentDetailsInfo').modal('hide');
        
    }

    onViewPaymentDetails(expandPaymentDetails = false) {
        const self = this;
        let url = "";
        if(expandPaymentDetails){
            url = '/developer/sales/payments/'+ self.sale.id + '/details?div=paymentInformation';
        }else{
            url = '/developer/sales/payments/'+ self.sale.id + '/details/';
        }
        ($("#paymentDetailsInfo").modal('show'));
        self.$timeout(function() {
            self.$window.open(url, '_blank');
        }, 2*1000);
    }

    refreshPage(){
        const self = this;
        self.hideModals();
        self.$window.location.reload();
    }

    downloadDocument(document) {
        const self = this;

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': self.ASSET_MODEL_SALE_DOCUMENT,
            'id': document.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.presigned_url) {
                window.open(response.data.presigned_url, '_blank');
            }
        });
    }

    regenerateBuyerParticular() {
        const self = this;

        let url = 'sec/developer/sales/' + self.data.sale_id + '/re-generate-bpf';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let buyer_particular_obj = response.data;

            //Get pre-signed url
            let url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': buyer_particular_obj.id
            };

            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                window.open(response.data.presigned_url, '_blank');
            });

        });
    }

    prepareSaleParams() {
        const self = this;

        let saleParams = {};

        saleParams.order_no = self.sale.order_no;
        saleParams.purchase_mode = self.sale.purchase_mode;
        saleParams.tele_sales_no = self.sale.tele_sales_no;
        saleParams.staff_id = self.sale.staff_id;
        saleParams.referral_type = self.sale.referral_type;

        saleParams.referral_name = self.sale.referral_name;
        saleParams.referral_code = self.sale.referral_code;

        saleParams.remarks_for_lawyer = self.sale.remarks_for_lawyer;
        saleParams.requested_spa_issue_date = self.sale.requested_spa_issue_date;

        saleParams.is_management_sale = self.sale.is_management_sale == 1 ? true : false;
        saleParams.sale_type = self.sale.sale_type;

        return saleParams;
    }

    saveSaleParams(saleParams, callback) {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {

            let url = 'sec/developer/sales/' + self.sale.id + '/update-sale-fields';

            saleParams.is_management_sale = saleParams.is_management_sale ? 1 : 0;

            self.SSHttpService.putAPIRequest(url, saleParams).then(function (response) {
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                angular.merge(self.sale, saleParams);

                if (callback) {
                    callback();
                }
            });
        });
    }

    editSaleType(editMode) {
        const self = this;

        self.saleEditParams = editMode ? self.prepareSaleParams() : null;
        self.saleTypeEditMode = editMode;
    }

    saveSaleType() {
        const self = this;

        loading(true);
        self.saveSaleParams(self.saleEditParams, function (response) {
            loading(false);

            self.SSAlertService.success('Updated successfully.');
            self.saleTypeEditMode = false;
        });
    }


    editPurchaseMode(editMode) {
        const self = this;

        self.saleEditParams = self.prepareSaleParams();

        self.salePurchaseEditMode = editMode;
    }

    savePurchaseMode() {
        const self = this;

        loading(true);
        self.saveSaleParams(self.saleEditParams, function (response) {
            loading(false);

            self.SSAlertService.success('Updated successfully.');

            self.salePurchaseEditMode = false;
        });
    }

    editReferralInfo(editMode) {
        const self = this;

        self.saleReferralInfoParams = self.prepareSaleParams();

        self.saleReferralInfoEditMode = editMode;
    }

    saveReferralInfo() {
        const self = this;

        loading(true);
        self.saveSaleParams(self.saleReferralInfoParams, function (response) {
            loading(false);

            self.SSAlertService.success('Updated successfully.');

            self.saleReferralInfoEditMode = false;
        });
    }

    getReferralLabel() {
        const self = this;

        let referralType = self.saleReferralInfoEditMode ? self.saleReferralInfoParams.referral_type : (self.sale ? self.sale.referral_type : null);
        return self.SSConfigService.getReferralCodeLabel(referralType);
    }

    editSalePrice(editMode) {
        const self = this;

        if (!editMode) {
            self.sale.price = angular.copy(self.priceCopy);
        }

        self.salePriceEditMode = editMode;
    }

    // SALE COMMISSION & INCENTIVES
    editSaleAgency(editMode) {
        const self = this;

        self.saleCommissionsEditMode = editMode;

        self.saleCommissionsParams = {};
        self.saleCommissionsErrors = {};

        if (self.saleCommissionsEditMode) {
            self.saleCommissionsParams = {
                id: self.sale.id,
                is_management_sale: self.sale.is_management_sale == 1 ? true : false,
                agency_commission_value: self.sale.agency_commission_value,
                agency_commission_type: self.sale.agency_commission_type,
                agency_commission_gst_inclusive: self.sale.agency_commission_gst_inclusive == 1 ? true : false,
                broker_incentives_value: self.sale.broker_incentives_value,
                broker_incentives_type: self.sale.broker_incentives_type,
                broker_incentives_gst_inclusive: self.sale.broker_incentives_gst_inclusive == 1 ? true : false,
            };
        }
    }

    saveSaleAgency() {
        const self = this;
        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {

                if (self.saleCommissionsParams.agency_commission_value) {
                    if (!self.saleCommissionsParams.agency_commission_type) {
                        self.SSAlertService.warning('Missing Params!', 'Please select agency commission type.');
                        return;
                    }
                }

                if (self.saleCommissionsParams.broker_incentives_value) {
                    if (!self.saleCommissionsParams.broker_incentives_type) {
                        self.SSAlertService.warning('Missing Params!', 'Please select agent incentive type.');
                        return;
                    }
                }

                self.saleCommissionsParams.agency_commission_gst_inclusive = self.saleCommissionsParams.agency_commission_gst_inclusive ? 1 : 0
                self.saleCommissionsParams.broker_incentives_gst_inclusive = self.saleCommissionsParams.broker_incentives_gst_inclusive ? 1 : 0

                let url = 'sec/developer/sales/' + self.sale.id + '/agency-commissions';

                self.saleCommissionsErrors = {};

                self.saleCommissionsParams.is_management_sale = self.saleCommissionsParams.is_management_sale ? 1 : 0;

                loading(true);
                self.SSHttpService.putAPIRequest(url, self.saleCommissionsParams).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.saleCommissionsErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }

                    self.SSAlertService.success('Commissions updated successfully.');

                    angular.merge(self.sale, self.saleCommissionsParams);

                    self.editSaleAgency(false);
                });
            });
    }

    isManagementSaleChanged() {
        const self = this;

        if (self.saleCommissionsParams.is_management_sale) {
            self.saleCommissionsParams.agency_commission_value = 0;
            self.saleCommissionsParams.broker_incentives_value = 0;
        }
    }

    formatCommissionValue(type, value, gst_inclusive) {

        const self = this;

        if (!(type || value)) {
            return '--';
        }

        let _value = value;

        if (type == self.VALUE_TYPE_PERCENTAGE) {
            _value = _value + ' %';
        } else if (type == self.VALUE_TYPE_AMOUNT) {
            // WEB-3543: a GST-inclusive fixed amount already contains the GST
            // (it is the gross figure), so it is shown as-is — GST is never
            // added on top. This mirrors the Sale Details screen.
            _value = self.SSUtilService.formatCurrency(_value);
        }

        _value += ' (' + (gst_inclusive == 1 ? 'With' : 'Without') + ' GST)';

        return _value;
    }

    _saveSalePrice() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale.id + '/updateSalePrice';
        let params = {
            'price': self.sale.price
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.priceCopy = angular.copy(self.sale.price);
            self.SSAlertService.success('Success!', 'Sale Price updated successfully.');
            self.hideModals();
            self.editSalePrice(false);

        });
    }

    //Commissions & Incentives
    getPropertyCommissions() {
        let self = this;
        let url = 'sec/developer/properties/' + self.sale.unit.property_id + '/commissions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propertyCommissions = response.data.property_commissions;
            //Parsing Data to Object
            self.propertyCommissions.forEach(x => {
                if(x.data)
                    x.data = JSON.parse(x.data);
            });

            if(self.checkPermission('DMS_PYMTS_VW_COMM'))
            {
                //Get Sale Commissions
                self.getSaleCommissions();
            }
        });

    }

    getSaleCommissions() {
        let self = this;

        let url = 'sec/developer/sales/' + self.data.sale_id + '/commissions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.saleCommissions = response.data.sale_commissions;

            //Filter Appointed Agency Commissions
            // self.saleCommissions = self.saleCommissions.filter(x => x.type != 10);

            // WEB-3679: the Appointed Agency Commission (type 10) is edited on the
            // Sale Detail page as SALE-LEVEL fields (sale.agency_commission_* /
            // sale.broker_incentives_*) via a separate write path. The type-10
            // sale_commissions row is a stale shadow record the Detail page never
            // shows, so its GST-inclusive flag/values can diverge from what the
            // Detail page displays. Treat the sale-level fields as the source of
            // truth here so both pages label & value the commission identically,
            // and flag the row so its Edit/Delete (which write the shadow record)
            // are hidden on Review.
            self.saleCommissions.forEach(function (x) {
                if (x.type == 10 && self.sale) {
                    x.commission_amount_value  = self.sale.agency_commission_value;
                    x.commission_amount_type   = self.sale.agency_commission_type;
                    x.commission_gst_inclusive = self.sale.agency_commission_gst_inclusive;
                    x.incentives_amount_value  = self.sale.broker_incentives_value;
                    x.incentives_amount_type   = self.sale.broker_incentives_type;
                    x.incentives_gst_inclusive = self.sale.broker_incentives_gst_inclusive;
                    x.is_appointed_agency      = true;
                }
            });

            //Parsing Data to Object
            self.saleCommissions.forEach(x => {
                if(x.data) {
                    x.data = JSON.parse(x.data);
                }
            });
        });

    }

    nameConversion(value){
        const self = this;
        let _v = (value.toLowerCase()).replace(/[\s.]/g,'_').toString();
        return _v;
    }

    commissionFieldLabel(commission, field) {
        const self = this;

        let fieldLabel = field;

        let LABELS = {
            type: 'Commission Type',
            name: 'Commission Name',
            commission_amount_value : 'Commission Value',
            commission_amount_type : 'Commission Type',
            incentives_amount_value : 'Incentive Value',
            incentives_amount_type : 'Incentive Type',
            data : 'Data Set',
            data_name : 'Name of Field',
            data_fields : 'Data Fields',
            incentives_gst_inclusive:'Incentives: GST Inclusive',
            commission_gst_inclusive:'Commission: GST Inclusive'
        };
        return fieldLabel = LABELS[field];
    }

    editSaleCommission(editMode,sale_commission) {
        const self = this;
        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            self._editSaleCommission(editMode,sale_commission);
        });
    }

    _editSaleCommission(editMode,sale_commission) {
        const self = this;

        self.commissionEditMode = editMode;
        self.current_sale_commission_params = {};

        self.current_commission = angular.copy(sale_commission);

        self.current_sale_commission_params = {
            id: sale_commission.id,
            name : sale_commission.name,
            type : sale_commission.type,
            commission_amount_value: sale_commission.commission_amount_value,
            commission_amount_type: sale_commission.commission_amount_type,
            commission_gst_inclusive: sale_commission.commission_gst_inclusive,
            incentives_amount_value: sale_commission.incentives_amount_value,
            incentives_amount_type: sale_commission.incentives_amount_type,
            incentives_gst_inclusive: sale_commission.incentives_gst_inclusive,
            property_commission_id : sale_commission.property_commission_id,
            data : []
        };

        self.temporaryData = [];
        if(self.current_commission.data && self.checkSaleCommissionType(self.current_commission.data)) {
            for(let key in self.current_commission.data){
                self.current_sale_commission_params.data[key+'_name'] = key;
                self.current_sale_commission_params.data[key+'_id'] = key;
                self.current_sale_commission_params.data[key+"_value"] = [];

                self.propertyCommissions.forEach(function (value) {
                    if(value.data){
                        value.data.forEach(function (parentData) {
                            if(self.nameConversion(parentData.name) == key){
                                if(parentData.dataset) {
                                    parentData.dataset.forEach(function (data) {
                                        let valueCheck = true;
                                        //Selecting Already Selected Values
                                        self.current_commission.data[key].forEach(function (dataset) {
                                            if(data.id == dataset.id){
                                                self.current_sale_commission_params.data[key+"_value"].push(dataset);
                                                valueCheck = false;
                                            }
                                        });
                                        //Pushing Values from Property Commission
                                        if(valueCheck){
                                            self.current_commission.data[key].push(data);
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
                self.current_commission.data[key].push({id:"other",name:"OTHER"});

                self.temporaryData.push({
                    name: key,
                    dataset : self.current_commission.data[key]
                });
            }
            self.current_commission.data = self.temporaryData;
        }
        else{
            self.current_sale_commission_params.data = self.current_commission.data;
        }

        $('#sale_commission_name').prop('disabled',true);
        $('#AddCommissionModal').modal('show');

        $('#AddCommissionModal').on('hidden.bs.modal',function () {
            self.current_commission = {};
            self.commissionEditMode = false;
        });

    }

    deleteSaleCommission(sale_commission) {
        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
                    self._deleteSaleCommission(sale_commission);
                });
            }
        );
    }

    _deleteSaleCommission(sale_commission) {
        let self = this;

        self.hideModals();

        let url = 'sec/developer/sales/' + self.data.sale_id + '/commissions/'+sale_commission.id+'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.getSaleCommissions();
        });

    }

    parseSaleCommissionData(){
        const self = this;
        let temporaryDataArray = {};
        let valid = true;
        if(angular.isString(self.current_sale_commission_params.data)){
            return valid;
        }

        let propertyCommission = self.propertyCommissions.find(x => x.name == self.current_sale_commission_params.name);
        if(propertyCommission && propertyCommission.data){
            propertyCommission.data.forEach(function (data) {
                    let namedValue = self.nameConversion(data.name);
                    if(self.current_sale_commission_params.data[namedValue+"_value"] && self.current_sale_commission_params.data[namedValue+"_value"].hasOwnProperty('id')){
                        let newObj = {
                            id:self.current_sale_commission_params.data[namedValue+"_value"].id,
                            name:self.current_sale_commission_params.data[namedValue+"_value"].name
                        };
                        temporaryDataArray[namedValue] = Array(newObj);
                    }
                    else{
                        temporaryDataArray[namedValue] = self.current_sale_commission_params.data[namedValue + "_value"];
                        if(data.is_required){
                            if(!angular.isArray(self.current_sale_commission_params.data[namedValue + "_value"]) && !self.current_sale_commission_params.data[namedValue + "_value"])
                                valid = false;
                        }
                    }
            });
        }
        self.current_sale_commission_params.data = temporaryDataArray;
        return valid;
    }


    saveSaleCommission(){
        const self = this;
        let valid = self.parseSaleCommissionData();
        if(valid)
            self._saveSaleCommission();
    }

    _saveSaleCommission(){
        const self = this;

        let url = 'sec/developer/sales/' + self.data.sale_id + '/commissions';

        let params = angular.copy(self.current_sale_commission_params);

        if (!params) {
            return;
        }

        if(params.data){
            params.data = JSON.stringify(params.data);
        }else{
            params.data = null;
        }

        self.hideModals();

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!',  'Commission updated successfully.');
            self.getSaleCommissions();
            self.current_sale_commission_params = {};
            self.current_commission = {};
        };

        loading(true);
        if (self.current_sale_commission_params.id) {
            url += '/' + self.current_sale_commission_params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        }
        else{
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    showCommissionPopup(commission, $event) {
        const self = this;

        if ($event) {
            $event.stopPropagation();
        }

        self.hideModals();

        if (commission) {
            self.current_commission = angular.copy(commission);
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            self.current_commission = {};
            self.current_sale_commission_params = {};

            $('#sale_commission_name').prop('disabled', false);
            $('#AddCommissionModal').modal('show');
        });
    }

    commissionSelectionChange(){
        const self = this;

        self.current_commission = angular.copy(self.propertyCommissions.find(x => x.id == self.current_commission.id));
        self.current_sale_commission_params = angular.copy(self.current_commission);
        self.current_sale_commission_params['sale_id'] = self.data.sale_id;
        self.current_sale_commission_params['property_commission_id'] = self.current_sale_commission_params['id'];
        delete self.current_sale_commission_params['id'];

        self.current_sale_commission_params.data = {};

        if(self.current_commission.data) {
            self.current_commission.data.forEach((value, index) => {
                let named_value = self.nameConversion(value.name);
                self.current_sale_commission_params.data[named_value+'_name'] = named_value;
                self.current_sale_commission_params.data[named_value+'_id'] = named_value;
                self.current_sale_commission_params.data[named_value+"_value"] = null;
                if(value.dataset)
                    value.dataset.push({id:"other",name:"OTHER"});
            });
        }
        else{
            self.current_sale_commission_params.data = "";
        }
    }

    initSelectizejsClass() {
        const self = this;

        let $select = $('.selectize').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });
    }

    checkOutputForOther(key){
        const self = this;
        let check = false;
        if(angular.isArray(self.current_sale_commission_params.data[key+'_value'])) {
            self.current_sale_commission_params.data[key + '_value'].forEach(function (value) {
                if (value.id == 'other') {
                    self.current_sale_commission_params.data[key + '_id'] = 'other';
                    check = true;
                }
            });
        }
        else{
            if(self.current_sale_commission_params.data[key+'_value'].id == 'other'){
                self.current_sale_commission_params.data[key + '_id'] = 'other';
                check = true;
            }
        }
        if(check) {
            self.current_sale_commission_params.data[key + '_value'] = [];
        }
        else{
            self.current_sale_commission_params.data[key+'_id'] = key;
        }

    }

    checkSaleCommissionType(saleCommissionData){
        if(typeof (saleCommissionData) == 'object')
            return true;
        else if(typeof(saleCommissionData == 'string'))
            return false;
    }

    checkIfRequired(current_commission_data){
        const self = this;
        return current_commission_data.is_required;
    }

    editOtpOrderNo(check){
        const self = this;
        if(check){
            self.updateSaleEditMode = true;
            self.updateSaleParams.purchase_mode = self.sale.purchase_mode;
            self.updateSaleParams.staff_id = self.sale.staff_id;
            self.updateSaleParams.order_no = self.sale.order_no;
            self.updateSaleParams.tele_sales_no = self.sale.tele_sales_no;
            self.updateSaleParams.referral_type = self.sale.referral_type;
            self.updateSaleParams.referral_name = self.sale.referral_name;
            self.updateSaleParams.referral_code = self.sale.referral_code;
            self.updateSaleParams.is_management_sale = self.sale.is_management_sale;
            self.updateSaleParams.remarks_for_lawyer = self.sale.remarks_for_lawyer;
            if(self.sale.hasOwnProperty('requested_spa_issue_date'))
                self.updateSaleParams.requested_spa_issue_date = self.sale.requested_spa_issue_date;
        }
        else{
            self.updateSaleEditMode = false;
            self.updateSaleParams = {};
        }
    }

    saveOtpOrderNo(){
        const self = this;
        let url = 'sec/developer/sales/' + self.data.sale_id + '/update-sale-fields';

        let param = self.updateSaleParams;

        loading(true);
        self.SSHttpService.putAPIRequest(url, param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.hideModals();
                return;
            }
            self.sale.order_no = response.data.sale.order_no;
            self.editOtpOrderNo(false);
        });
    }

    getCommissionDividedValue(price,value,length,type,last,gst_amount,gst_inclusive){
        const self = this;
        let finalValue = 0;

        // WEB-3543: the split shown per party is always the raw (gross)
        // commission divided across parties. GST is displayed separately and is
        // never added on top of the split — for a GST-inclusive commission the
        // raw figure already contains the GST (Sale Details convention).
        if(length == 1 || !last) {
            if (type == self.VALUE_TYPE_PERCENTAGE) {
                return finalValue = (price * (value) / 100) / length;
            }
            else if (type == self.VALUE_TYPE_AMOUNT) {
                return finalValue = (value) / length;
            }
        }
        else{
            let commission = 0;
            if (type == self.VALUE_TYPE_PERCENTAGE) {
                commission = (price * (value) / 100);
            }
            else if (type == self.VALUE_TYPE_AMOUNT) {
                commission = value;
            }

            // Last party absorbs any rounding remainder so the parts sum to the total.
            finalValue = parseFloat(commission / length).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            finalValue = finalValue.replace(',', '');
            finalValue = parseFloat(finalValue);
            if((finalValue * length) != commission)
                finalValue += (commission - (finalValue * length));

            return finalValue;
        }
    }

    // GST added on top of a GST-exclusive (net) amount: price * gst%.
    getGstAmount(price){
        const self = this;
        let value = 0;
        let gst = self.sale.gst_value ? self.sale.gst_value : 0;
        if(!price)
            return 0;

        value = price * gst / 100;
        return value;
    }

    // WEB-3543: GST contained within a GST-inclusive (gross) amount.
    // The gross already includes the GST, so the GST portion is
    // price - price/(1 + gst%). This aligns the Sale Review screen with the
    // Sale Details screen (payment_details.js, PR #330) instead of adding GST
    // on top of an already-inclusive commission.
    getGstExtractedAmount(price){
        const self = this;
        let gst = self.sale.gst_value ? self.sale.gst_value : 0;
        if(!price)
            return 0;

        return price - (price / ((gst / 100) + 1));
    }

    skipDocumentUpload() {
        const self = this;

        self.hideModals();
        self.showAccept = true;
        $('#developerSaleApplicationAcceptModal').modal('show');
    }

    /**
     * Heartbeat that keeps the sale review lock alive while this page is open.
     *
     * @remarks
     * WEB-4375: migrated from the legacy per-sale lock ping endpoint to the
     * unified `sec/locks/{lockName}/ping`, using the `lock_name` returned by
     * acquire. Ping performs no entity validation, so the sale-status
     * sub-codes the old handler could return here (305024 / 305013 / 305010)
     * are no longer reachable; what remains is 1100001 (taken over by another
     * user), 1100002 (lock gone) and 1100003 (session expired). On any of
     * those the loop stops instead of rescheduling — none of them recover by
     * retrying.
     *
     * @returns {void}
     */
    pingSaleLock() {
        const self = this;

        if (!self.sale_lock_name) {
            return;
        }

        let lock_name = self.sale_lock_name;

        self.SSLockService.ping(lock_name).then(function (response) {
            if (response instanceof Error) {
                if (response.sub_code == self.SSLockService.SUB_CODE_LOCK_CONFLICT) {
                    self.SSAlertService.danger(
                        "Error!",
                        "This sale is being assessed by "
                            + self.SSLockService.getLockingUserName(response) + "."
                    );
                } else {
                    self.SSAlertService.parseAndDisplayServerError(response);
                }

                // The lock is no longer ours; stop claiming it.
                self.sale_lock_name = null;
                return;
            }

            // The page may have been torn down while this ping was in flight.
            if (self.sale_lock_name !== lock_name) {
                return;
            }

            // Auto refresh
            self.lock_ping_promise = self.$timeout(function () {
                self.pingSaleLock();
            }, 4 * 1000);
        });
    }

    /**
     * Acquire the sale review lock for this page and start the heartbeat.
     *
     * @remarks
     * WEB-4375: migrated to the unified `sec/locks/acquire`. The lock was
     * normally already taken on the applications listing before navigating
     * here; re-acquiring as the same user simply resets the expiry.
     *
     * No `override` is offered on this page: the listing already asked the
     * user whether to take the sale off its current holder, so arriving here
     * against someone else's lock means the answer was no (or the page was
     * opened directly by URL).
     *
     * @returns {void}
     */
    initLockSale() {
        const self = this;

        loading(true);
        self.SSLockService.acquire(
            self.SSLockService.ENTITY_TYPE_SALE,
            self.data.sale_id,
            self.LOCK_TYPE_SALE_APPLICATION_REVIEW
        ).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == self.SSLockService.SUB_CODE_LOCK_CONFLICT) {
                    self.SSAlertService.danger(
                        "Error!",
                        "This sale is being assessed by "
                            + self.SSLockService.getLockingUserName(response) + "."
                    );
                } else if (response.sub_code == 305024) {
                    // The unified endpoint returns 305024 for every status
                    // that is not VERIFIED, not just "already approved".
                    self.SSAlertService.danger("Error!", "This sale is not pending review.");
                } else if (response.sub_code == 305010) {
                    self.SSAlertService.danger("Error!", "Cannot find sale.");
                } else {
                    self.SSAlertService.parseAndDisplayServerError(response);
                }

                return;
            }

            self.sale_lock_name = response.data
                ? response.data.lock_name
                : self.SSLockService.getLockName(
                      self.SSLockService.ENTITY_TYPE_SALE,
                      self.data.sale_id,
                      self.LOCK_TYPE_SALE_APPLICATION_REVIEW
                  );

            self.pingSaleLock();
        });
    }

    /**
     * Release the sale review lock whenever this page goes away.
     *
     * @remarks
     * WEB-4375: the review page is left in several ways that do not run
     * {@link onRedirectBackToListing} — closing the tab, the browser Back
     * button, a session-expiry redirect, or any other link. `beforeunload`
     * covers all of them; `$destroy` is a belt-and-braces hook for the
     * controller being torn down without a navigation. Both paths are safe to
     * fire more than once because releaseSaleLock() clears `sale_lock_name`.
     *
     * @returns {void}
     */
    initLockTeardown() {
        const self = this;

        self.onLockPageUnload = function () {
            self.releaseSaleLock('Left sale review page', true);
        };

        self.$window.addEventListener('beforeunload', self.onLockPageUnload);

        self.$scope.$on('$destroy', function () {
            self.$window.removeEventListener('beforeunload', self.onLockPageUnload);
            self.releaseSaleLock('Sale review page closed', true);
        });
    }

    /**
     * Stop the heartbeat and release the sale review lock.
     *
     * @remarks
     * WEB-4375: the legacy endpoints had no release and expired a lock after
     * 5 seconds, so simply leaving the review page cleared it. The unified
     * endpoints default to a 300-second expiry, so the lock has to be handed
     * back explicitly or the sale stays blocked for the next reviewer for up
     * to five minutes.
     *
     * @param {string}  [reason]   Free text stored on the lock audit trail.
     * @param {boolean} [onUnload] True when the page is being torn down, in
     *                             which case the release is sent as a beacon
     *                             so the navigation cannot cancel it.
     * @returns {void}
     */
    releaseSaleLock(reason, onUnload) {
        const self = this;

        if (self.lock_ping_promise) {
            self.$timeout.cancel(self.lock_ping_promise);
            self.lock_ping_promise = null;
        }

        if (!self.sale_lock_name) {
            return;
        }

        if (onUnload) {
            self.SSLockService.releaseOnUnload(self.sale_lock_name, reason);
        } else {
            self.SSLockService.release(self.sale_lock_name, reason);
        }

        self.sale_lock_name = null;
    }

    parseDate(date) {
        const self = this;

        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }
    checkFieldAvailablity(field){
        const self = this;
        if(field == undefined)
            return false;
        if(field == null)
            return false;
        return true;
    }

    searchAgent() {
        const self = this;

        self.agents = [];
        let url = 'agents/search';
        let params = {
            criteria: self.criteria
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.agents) {


                if(response.data.agents.length)

                self.agents = response.data.agents;
                    $.each(self.agents, function (index, agent) {
                        if (self.SSEoiService.brokers_obj && self.SSEoiService.brokers_obj.find(x => x.user_id == agent.user_id)) {
                            agent["unselected"] = false;
                        } else {
                            agent["unselected"] = true;
                        }
                    })
            }

            self.searched = true;
        });
    }

    selectRole(agent, checkRole = false) {
        const self = this;
        if (agent.broker_role === 1) {
            
            $.each(self.brokersDetailCopy, function (i, broker) {
                if (broker.role_id == agent.broker_role) {
                    delete agent.role_name;
                    self.SSAlertService.danger("Error!", "Only 1 buyer agent is allowed.");
                        self.$timeout(function () {
                            $("select.form-control").niceSelect('update');
                        });
                }
            });
        }
        // if (agent.broker_role === 5) {
        //     // Broker Role 5 = Sales consultant
        //     let filtered_array = self.SSEoiService.brokers_obj.filter(x => x.broker_role === 5);
        //     if (filtered_array.length > 1) {
        //         agent.broker_role = old_role;
        //         self.SSAlertService.danger("Error!", "Only 1 sales consultant is allowed.");
        //         self.$timeout(function () {
        //             $("select.eoi-select").niceSelect('update');
        //         });
        //         return;
        //     }
        // }
        if(agent.broker_role)
            agent["role_name"] = self.SSEoiService.broker_roles.find(x => x.id === agent.broker_role).name;
    }

    selectAndSaveRole(broker){
        const self = this;
        let firstBuyer = false;
        if (broker.role_id === 1) {
            $.each(self.brokersDetailCopy, function (i, brokerDetail) {
                if (brokerDetail.role_id == broker.role_id) {
                    if(!firstBuyer){
                        firstBuyer = true;
                        return;
                    }
                    delete broker.role_name;
                    self.SSAlertService.danger("Error!", "Only 1 buyer agent is allowed.");
                    self.$timeout(function () {
                        $("select.form-control").niceSelect('update');
                    });
                    broker.role_id = null;
                }
            });
        }
        self.addBrokerParams.filter(x => x[0] == broker.user_id)[0][1] = broker.role_id;
        if(broker.role_id){
            broker["role_name"] = self.SSEoiService.broker_roles.find(x => x.id === broker.role_id).name;
        }
    }

    checkRole(agent){
        const self = this;
        if(!agent) return false;
        if(!agent.broker_role) return false;
        if(agent.broker_role == 1){
            let check = true;
            $.each(self.brokersDetailCopy, function (i, broker) {
                if (broker.role_id == agent.broker_role) {
                    check = false;
                    return;
                }
            });
            return check;
        }
        return true;
    }

    addBroker(agent){
        const self = this;

        if(!self.checkRole(agent)) return;

        let checkAgent = null;
        checkAgent = self.brokersDetailCopy.find(x => x.user_id == agent.user_id);
        if(checkAgent){
            self.SSAlertService.danger("Cannot Add!", "Agent already exists.");
            return;
        }
        let broker = self.agents.find(x => x.user_id == agent.user_id);
        if(broker.agency_name){
            if(!broker.hasOwnProperty("agency")){
                broker["agency"] = {};
                broker.agency.name = broker.agency_name;
                delete broker.agency_name;
            }
        }
        broker['role_name'] = self.SSEoiService.broker_roles.find(x => x.id == broker.broker_role).name;
        broker['role_id'] = broker.broker_role;
        delete broker.broker_role;
        self.brokersDetailCopy.push(broker);
        self.addBrokerParams.push([agent.user_id,agent.role_id]);
        let filtered_array = self.agents.filter(x => x.user_id !== agent.user_id);
        self.agents = filtered_array;
        

    }

    removeBroker(broker){
        const self = this;
        let filtered_array = self.brokersDetailCopy.filter(x => x.user_id != broker.user_id);
        if(filtered_array.length == 0){
            self.SSAlertService.danger("Error!","Cannot remove all Brokers");
            return;
        }
        self.brokersDetailCopy_copy = angular.copy(self.brokersDetailCopy);
        self.brokersDetailCopy = filtered_array;
        let paramFiltered_array = self.addBrokerParams.filter(x => x[0] != broker.user_id);
        self.addBrokerParams = paramFiltered_array;
    } 

    saveBroker(){
        const self = this;
        let url = "sec/developer/sales/" + self.data.sale_id + "/brokers";
        loading(true);
        self.SSHttpService.postAPIRequest(url,self.addBrokerParams).then(function (response){
            loading(false);
            if (response instanceof Error) {
                if(response.code == 412){
                    if(response.data && response.data.brokers && response.data.brokers.length>0){
                        self.SSAlertService.danger(response.data.brokers[0]);
                    }
                }
                else{
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            else{
                self.brokereditMode = false;
            }
        });

    }

    editBroker(check){
        const self = this;
        if(!check){
            self.brokersDetailCopy = self.brokersDetailCopy_copy;
        }
        self.criteria = "";
        self.searched = false;
        self.brokereditMode = check;

    }
    getSaleOtpRepresentative(){
        const self = this;
        let url = "sec/developer/sales/" + self.data.sale_id + "/sale-otp-representatives";
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if(response.data && response.data.sale_otp_representative){

                self.saleOtpRepresentative = response.data.sale_otp_representative;
            }
        });
    }

    getDeveloperUsers() {
        const self = this;

        let url = "sec/developer/users";
		let params = {
			status: 1,
			limit: 50,
            include_me: 1
		}

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response.data && response.data.users) {
				self.developer_users = response.data.users;

            }
        });
    }

    checkDocumentType(){
        const self = this;
        
        if(self.sale.property){
            if(self.sale.property.settings && self.sale.property.settings.length>0){
                let otpSpaSettigs = self.sale.property.settings.find(x => x.name == "otp_spa");
                if(otpSpaSettigs){
                    return otpSpaSettigs.value == "SPA" ? "SPA":"OTP";
                }
                else{
                    return "OTP";
                }
            }
            else{
                return "OTP";
            }
        }
        else{
            return "OTP";
        }
    }

    nextPage() {
        const self = this;
        var totalPages = Math.ceil(Object.keys(self.sale.other_documents).length / self.pageSize);
        if (self.currentPage < totalPages) {
            self.currentPage++;
        }
    };

    previousPage() {
        const self = this;
        if (self.currentPage > 1) {
          self.currentPage--;
        }
    };

    getCurrentDocument() {
        const self = this;
        if(!self.sale) return;
        var startIndex = (self.currentPage - 1) * self.pageSize;
        var endIndex = startIndex + self.pageSize;
        if (self.sale.other_documents) {
            return Object.values(self.sale.other_documents).slice(startIndex, endIndex);
        }
        return [];
    }

    hasMoreDocuments() {
        const self = this;
        if(!(self.sale && self.sale.other_documents)) return;
        return self.currentPage < Math.ceil(Object.keys(self.sale.other_documents).length / self.pageSize);
    };

    editSaleSpecialConditions(check){
        const self = this;
        if(check){
            self.saleSpecialConditionsEditMode = true;
        }
        else{
            self.saleSpecialConditionsEditMode = false;
            self.saleQuestionSpecialConditionsParams = angular.copy(self.saleQuestionSpecialConditions);
        }
    }

    saveSaleSpecialConditions() {
        const self = this;
        let url = 'sec/sales/' + self.data.sale_id + '/questions-answers';

        let param = {
            property_question_id: self.saleQuestionSpecialConditionsParams.id,
            answer_text: self.saleQuestionSpecialConditionsParams.answer_text
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.hideModals();
                return;
            }
            self.saleQuestionSpecialConditions.answer_text = response.data.sale_question_answer.answer_text;
            self.editSaleSpecialConditions(false);
        });
    }

    /** WEB-2901 FATF Black List - Indications - START **/
    getDeveloperSettings(){
        const self = this;

        let url = 'sec/developer/settings';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            self.prepareSaleObject();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){
                let fatf_blacklist_countries_settings = self.SettingsService.getSetting(response.data.developer_settings, 'fatf_blacklist_countries');
                let occupations_blacklist_settings = self.SettingsService.getSetting(response.data.developer_settings, 'blacklist_occupations');
                let cbi_rbi_countries_settings = self.SettingsService.getSetting(response.data.developer_settings, 'cbi_rbi_countries');
                let sale_review_settings = self.SettingsService.getSetting(response.data.developer_settings, 'sale_review_settings');
                if(fatf_blacklist_countries_settings
                    && fatf_blacklist_countries_settings.value
                    && fatf_blacklist_countries_settings.value.length){
                    self.fatf_blacklist_countries = fatf_blacklist_countries_settings.value;
                }

                if(cbi_rbi_countries_settings
                    && cbi_rbi_countries_settings.value
                    && cbi_rbi_countries_settings.value.length){
                    self.cbi_rbi_countries = cbi_rbi_countries_settings.value;
                }

                if(occupations_blacklist_settings
                        && occupations_blacklist_settings.value
                        && Object.keys(occupations_blacklist_settings.value).length) {
                    self.occupations_blacklist = occupations_blacklist_settings.value;
                }

                /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed
                 * Only need to check mandatory document click if setting is enabled **/
                if(sale_review_settings && sale_review_settings.value){
                    self.sale_review_settings = sale_review_settings.value;
                    if (!self.sale_review_settings || !self.sale_review_settings.developer
                            || !self.sale_review_settings.developer.mandatory_documents_click) {
                        self.all_docs_viewed = true;
                    }
                } else {
                    self.all_docs_viewed = true;
                }
            }
        })
    }

    checkBuyersAgainstFatfList(buyerType){
        /** WEB-2901 FATF Black List - Indications
         * Add indicator to buyer(buyer, beneficiary, 3rd Party Payor) object
         * if country_of_origin or nationality lies in FATF blacklist **/
        const self = this;

        if (!self.sale) { return false; }

        if(buyerType === "BUYER"
                && self.sale.buyers && self.sale.buyers.length){
            self.sale.buyers= self.sale.buyers.map((buyer)=>{
                if(buyer.individual){
                    if(buyer.individual.country_of_origin
                        && self.fatf_blacklist_countries.indexOf(buyer.individual.country_of_origin) > -1){
                        buyer.is_from_fatf_blacklisted_country = true;
                    }
                    if(buyer.individual.nationality
                        && self.fatf_blacklist_countries.indexOf(buyer.individual.nationality) > -1){
                        buyer.is_from_fatf_blacklisted_country = true;
                    }

                    /** WEB-3061 Citizenship by Investment (CBI) and Residency by Investment (RBI) programs
                     * Show indicator if country or nationality in cbi/rbi list **/
                    if(buyer.individual.country_of_origin
                        && self.cbi_rbi_countries.indexOf(buyer.individual.country_of_origin) > -1){
                        buyer.is_from_cbi_rbi_country = true;
                    }
                    if(buyer.individual.nationality
                        && self.cbi_rbi_countries.indexOf(buyer.individual.nationality) > -1){
                        buyer.is_from_cbi_rbi_country = true;
                    }

                    /** WEB-3058 Black List Occupations
                     * Show indicator if buyer occupation is in blacklist **/
                    if (buyer.individual.industry
                            && self.occupations_blacklist[buyer.individual.industry]
                            && self.occupations_blacklist[buyer.individual.industry].length) {
                        if (buyer.individual.occupation
                                && self.occupations_blacklist[buyer.individual.industry].indexOf(buyer.individual.occupation) > -1){
                            buyer.has_blacklisted_occupation = true;
                        }
                    }
                } else if(buyer.company){
                    if(buyer.company.nationality
                        && self.fatf_blacklist_countries.indexOf(buyer.company.nationality) > -1){
                        buyer.is_from_fatf_blacklisted_country = true;
                    }
                    if(buyer.company.nationality
                        && self.cbi_rbi_countries.indexOf(buyer.company.nationality) > -1){
                        buyer.is_from_cbi_rbi_country = true;
                    }
                }
                return buyer;
            })

        }
        if(buyerType === "BENEFICIARY"
                && self.sale.beneficiaries && self.sale.beneficiaries.length){
            self.sale.beneficiaries= self.sale.beneficiaries.map((beneficiary)=>{
                if(beneficiary.country_of_origin
                    && self.fatf_blacklist_countries.indexOf(beneficiary.country_of_origin) > -1){
                    beneficiary.is_from_fatf_blacklisted_country = true;
                }
                if(beneficiary.nationality
                    && self.fatf_blacklist_countries.indexOf(beneficiary.nationality) > -1){
                    beneficiary.is_from_fatf_blacklisted_country = true;
                }

                if(beneficiary.country_of_origin
                    && self.cbi_rbi_countries.indexOf(beneficiary.country_of_origin) > -1){
                    beneficiary.is_from_cbi_rbi_country = true;
                }
                if(beneficiary.nationality
                    && self.cbi_rbi_countries.indexOf(beneficiary.nationality) > -1){
                    beneficiary.is_from_cbi_rbi_country = true;
                }
                return beneficiary;
            })
        }
        if(buyerType === "NON_BUYER_PAYEE"
                && self.sale.non_buyer_payees && self.sale.non_buyer_payees.length){
            self.sale.non_buyer_payees= self.sale.non_buyer_payees.map((non_buyer_payee)=>{
                if(non_buyer_payee.individual){
                    if(non_buyer_payee.individual.country_of_origin
                        && self.fatf_blacklist_countries.indexOf(non_buyer_payee.individual.country_of_origin) > -1){
                        non_buyer_payee.is_from_fatf_blacklisted_country = true;
                    }
                    if(non_buyer_payee.individual.nationality
                        && self.fatf_blacklist_countries.indexOf(non_buyer_payee.individual.nationality) > -1){
                        non_buyer_payee.is_from_fatf_blacklisted_country = true;
                    }

                    if(non_buyer_payee.individual.country_of_origin
                        && self.cbi_rbi_countries.indexOf(non_buyer_payee.individual.country_of_origin) > -1){
                        non_buyer_payee.is_from_cbi_rbi_country = true;
                    }
                    if(non_buyer_payee.individual.nationality
                        && self.cbi_rbi_countries.indexOf(non_buyer_payee.individual.nationality) > -1){
                        non_buyer_payee.is_from_cbi_rbi_country = true;
                    }


                    /** WEB-3058 Black List Occupations
                     * Show indicator if 3rd Party Payor occupation is in blacklist **/
                    if (non_buyer_payee.individual.industry
                        && self.occupations_blacklist[non_buyer_payee.individual.industry]
                        && self.occupations_blacklist[non_buyer_payee.individual.industry].length) {
                        if (non_buyer_payee.individual.occupation
                            && self.occupations_blacklist[non_buyer_payee.individual.industry].indexOf(non_buyer_payee.individual.occupation) > -1){
                            non_buyer_payee.has_blacklisted_occupation = true;
                        }
                    }
                } else if(non_buyer_payee.company){
                    if(non_buyer_payee.company.nationality
                        && self.fatf_blacklist_countries.indexOf(non_buyer_payee.company.nationality) > -1){
                        non_buyer_payee.is_from_fatf_blacklisted_country = true;
                    }

                    if(non_buyer_payee.company.nationality
                        && self.cbi_rbi_countries.indexOf(non_buyer_payee.company.nationality) > -1){
                        non_buyer_payee.is_from_cbi_rbi_country = true;
                    }
                }
                return non_buyer_payee;
            })

        }
    }
    /** WEB-2901 FATF Black List - Indications - END **/

    /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed - START **/
    showActionNotAllowedMsg() {
        const self = this;

        if (!self.all_docs_viewed) {
            self.SSConfirmationService.getConfirmed(
                'Notice!',
                'Need to view all documents before performing this action.',
                self.SSConfirmationService.TYPE_OK,
                function () { }
            );
        }
    }

    checkAllDocsViewed() {
        const self = this;

        let documents = self.sale && self.sale.other_documents? Object.values(self.sale.other_documents) : null;
        let pending_view_docs = documents && documents.length? documents.find(d => !d.is_viewed) : null;
        if (!pending_view_docs) { // If no document remains to be viewed by user
            self.all_docs_viewed = true;
        }
    }
    /** WEB-3055 DMS - Review New Sale - Disable action buttons till all documents are viewed - END **/

    /** WEB-3070 AMS/DMS: Verify EOI and Review Sale- Show Witness Information - START **/
    getSalesWitnesses() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale.id + '/witnesses';
        let params = {
            'include': 'individual, primary_address, email_contact, phone1_contact, phone2_contact, documents',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.sale_witnesses && response.data.sale_witnesses.length > 0) {
                self.sale.witnesses = response.data.sale_witnesses;
                self.sale.witnesses = _.sortBy(self.sale.witnesses, 'order');

                $.each(self.sale.witnesses, function(index, witness) {
                    if (witness.data && typeof witness.data == "string") {
                        try{
                            witness.data = JSON.parse(witness.data);
                            witness.processed_data = witness.data;
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    witness.order = witness.order || index + 1;
                })
            }
        })
    }
    /** WEB-3070 AMS/DMS: Verify EOI and Review Sale- Show Witness Information - END **/
}

SalesApplicationSummaryController.$inject = [
    '$scope',
    '$window',
    '$timeout',
    'Fullscreen',
    'SSAppService',
    'SSHttpService',
    'SSUtilService',
    'SSDateService',
    'SSAlertService',
    'SSConfirmationService',
    'SSConfigService',
    'SSUserService',
    'SSEoiService',
    'OTPService',
    'SettingsService',
    'SSLockService'
];
app.controller('SalesApplicationSummaryController', SalesApplicationSummaryController);

app.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last == true) {
                $timeout(function () {
                    scope.$emit('ngRepeatFinished');
                });
            }
        }
    }
});
